// import { Component, ElementRef, ViewChild, OnDestroy, OnInit } from '@angular/core';
// import * as bootstrap from 'bootstrap';
// import { HomeService } from '../services/home.service';
// import { Subscription, debounceTime, interval, Subject, takeUntil, forkJoin, of } from 'rxjs';
// import { WebSocketService } from '../services/web-socket.service';
// import { NgToastService } from 'ng-angular-popup';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { HttpClient } from '@angular/common/http';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import { AuthService } from '../services/auth.service';
// import { MatDialog } from '@angular/material/dialog';
// import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';
// import { ConfigService } from '../services/config.service';
// import { Meta, Title } from '@angular/platform-browser';
// import { catchError } from 'rxjs/operators';
// import { HostListener } from '@angular/core';
// @Component({
//   selector: 'app-homepage',
//   templateUrl: './homepage.component.html',
//   styleUrls: ['./homepage.component.scss'],
// })
// export class HomepageComponent implements OnInit, OnDestroy {
//   @ViewChild('exampleModalGold', { static: false }) modalElement!: ElementRef;

//   showDiv = {
//     previous: true,
//     current: true,
//     next: true,
//   };

//   livePrice: any;
//   spotGold: any;
//   spotSilver: any;
//   spotINR: any;
//   primium: any = 0;
//   spotGoldUpdate: any;
//   spotSilverUpdate: any;
//   isGold: boolean = true;
//   previousSpotSilverUpdate: any;
//   spotSilverColor: string = '#e1b737';
//   isLogin: any;
//   isNotAllowedTime: boolean = true;
//   fAmount!: number;

//   // Forms
//   buyGoldForm: FormGroup;
//   bookSilverForm: FormGroup;
//   bookGoldForm: FormGroup;

//   isTotal: boolean = false;
//   isAmountLessThan110: boolean = false;
//   isAmountLessThan1000: boolean = false;
//   goldMaxLimit: any;
//   silverMaxLimit: any;
//   kyc_status: any;
//   silverPrimium: any = 0;
//   treding: boolean = false;
//   isWeekendDay: boolean = false;
//   phoneNumbers: string[] = [];
//   timings: string = '';
//   whatsappNumber: string = '';
//   email: string = '';
//   address: string = '';
//   companyname: any;
//   backGroundColor: any;
//   colorChangeTimeout: any;
//   usrID: any;
//   profileDetails: any;
//   timingsData: any;
//   shouldShowAlert: boolean = false;
//   buySilverRate: any;
//   buyGoldRate: any;

//   timerBuy: number = 30;
//   timerSubscriptionBuy: Subscription | null = null;
//   stayBuyGoldRate: any;
//   stayBuySilverRate: any;

//   now: Date = new Date();

//   previousSpotGoldUpdate: any = 0;
//   previousSpotINRUpdate: any = 0;
//   spotGoldColor: string = '#e1b737';
//   spotINRColor: string = '#e1b737';
//   data: string | undefined;

//   // Price locking properties
//   priceLocked: boolean = false;
//   lockedGoldPrice: any = null;
//   lockedSilverPrice: any = null;
//   lockTimer: number = 0;
//   lockInterval: any = null;
// newgoldcard:boolean=false;

//   private destroy$ = new Subject<void>();
//   private timeSubscription: Subscription | undefined;
//   public socketSubscription: Subscription | undefined;
//   public livePriceSubscription: Subscription | undefined;

//   // Token keys to check
//   private readonly TOKEN_KEYS = [
//     'user-access',
//     'token',
//     'user-token-goldBharatFirst'
//   ];
// private pendingProductModal: 'gold' | 'silver' | null = null;
//   route: any;

//   constructor(
//     private home: HomeService,
//     private webSocketService: WebSocketService,
//     private toast: NgToastService,
//     private spinner: NgxSpinnerService,
//     private http: HttpClient,
//     private fb: FormBuilder,
//     private router: Router,
//     private auth: AuthService,
//     public dialog: MatDialog,
//     private configService: ConfigService,
//     private meta: Meta,
//     private titleService: Title
//   ) {
//     // Initialize forms with correct names and default values
//     this.bookGoldForm = this.fb.group({
//       product_name: ['Gold'],
//       quantity_purchased: ['', [Validators.required]],
//       book_rate: [
//         '',
//         [
//           Validators.required,
//           Validators.pattern('^\\d*\\.?\\d*$'),
//         ],
//       ],
//       order_type: ['Gold'],
//     });

//     this.bookSilverForm = this.fb.group({
//       product_name: ['Silver'],
//       quantity_purchased: ['', [Validators.required]],
//       book_rate: [
//         '',
//         [
//           Validators.required,
//           Validators.pattern('^\\d*\\.?\\d*$'),
//         ],
//       ],
//       order_type: ['Silver'],
//     });

//     this.buyGoldForm = this.fb.group({
//       product_name: [''],
//       quantity_purchased: ['', [Validators.required]],
//       purchased_price: [''],
//       order_type: [''],
//     });
//   }

//   ngOnInit(): void {
//     this.home.getInitialRates().subscribe((res:any)=>{
//   console.log(res);

//   this.spotGoldUpdate = res.carat24.sell_price_per_gram;
//   this.spotSilverUpdate = res.silverPrice.sell_price_per_gram;
// });
//     this.initializeComponent();

//     const modalIds = ['buyGoldModalNewSilver', 'buySilverModal', 'buyGoldModalNew', 'buyGoldModal'];

//     this.route.queryParams
//   .pipe(takeUntil(this.destroy$))
//   .subscribe((params: { [x: string]: string | null; }) => {
//     if (params['openModal'] === 'gold' || params['openModal'] === 'silver') {
//       this.pendingProductModal = params['openModal'];
//     }
//   });
//   }
// ngAfterViewInit(): void {
//   const modalIds = ['buyGoldModalNew', 'buyGoldModal', 'bookGoldModal', 'buySilverModal', 'bookSilverModal'];

//   modalIds.forEach(id => {
//     const modalEl = document.getElementById(id);
//     modalEl?.addEventListener('hidden.bs.modal', () => {
//       this.clearModalBackdrop();
//     });
//   });
// }
//   private initializeComponent(): void {
//     // Clean up any corrupted data first
//     this.cleanupLocalStorage();

//     // Initialize in parallel where possible
//     forkJoin({
//       config: this.loadConfigSafe(),
//       initialRates: this.home.getInitialRates().pipe(catchError(() => of(null)))
//     }).subscribe({
//       next: (results) => {
//         if (results.config) {
//           this.applyConfig(results.config);
//         }
//         if (results.initialRates) {
//           this.handleInitialRates(results.initialRates);
//         }
//       },
//       complete: () => {
//         // These don't depend on each other
//         this.checkLoginAndTime();
//         this.checkTime();
//         this.setMetaTags();
//         this.setupRouterEvents();
//         this.setupWebSocket();
//         this.startTimeUpdates();
//         this.isWeekend();

//   this.handlePendingProductModal();  
//       }
//     });
//   }

//   /**
//    * Clean up corrupted localStorage data
//    */
//   private cleanupLocalStorage(): void {
//     // Remove any 'undefined' string values
//     const keysToCheck = ['userData', 'user-details-goldBharat', 'user-token-goldBharatFirst'];
//     keysToCheck.forEach(key => {
//       const value = localStorage.getItem(key);
//       if (value === 'undefined' || value === 'null') {
//         localStorage.removeItem(key);
//       }
//     });

//     // Validate userData JSON
//     const userDataString = localStorage.getItem('userData');
//     if (userDataString) {
//       try {
//         JSON.parse(userDataString);
//       } catch {
//         // Corrupted JSON, remove it
//         localStorage.removeItem('userData');
//       }
//     }
//   }

//   /**
//    * Safely load config
//    */
//   private loadConfigSafe() {
//     return this.configService.loadConfig().pipe(
//       catchError(error => {
//         console.error('Error loading config:', error);
//         return of(null);
//       })
//     );
//   }

//   /**
//    * Apply config data
//    */
//   private applyConfig(config: any): void {
//     if (config?.contact) {
//       this.phoneNumbers = config.contact.phoneNumbers || [];
//       this.timings = config.contact.timings || '';
//       this.whatsappNumber = config.contact.whatsappNumber || '';
//       this.email = config.contact.email || '';
//       this.address = config.contact.address || '';
//       this.companyname = config.company?.companyname || '';
//       this.backGroundColor = config.company;
//     }
//   }

//   /**
//    * Handle initial rates
//    */
//   private handleInitialRates(data: any): void {
//     if (data) {
//       this.spotGoldUpdate = data.carat24?.sell_price_per_gram;
//       this.spotSilverUpdate = data.silverPrice?.sell_price_per_gram;
//       this.spotGold = data.carat24?.spot_gold;
//       this.spotSilver = data.silverPrice?.spot_silver;
//       this.spotINR = data.carat24?.spot_inr;
      

      
//       // Set initial buy rates
//       this.stayBuyGoldRate = this.spotGoldUpdate;
//       this.stayBuySilverRate = this.spotSilverUpdate;
      
//       console.log('Initial rates loaded:', {
//         gold: this.spotGoldUpdate,
//         silver: this.spotSilverUpdate
//       });
//     }
//   }

//   private setMetaTags(): void {
//     this.titleService.setTitle('Buy Gold & Silver In Bulk At Best Price | Goldbharat');

//     this.meta.updateTag({
//       name: 'description',
//       content: 'Buy bulk gold and silver at unbeatable prices. Secure your wealth with high-quality precious metals, ideal for investors seeking long-term reliability and value protection.',
//     });

//     this.meta.updateTag({
//       name: 'keywords',
//       content: 'buy gold wholesale, buy gold in bulk, buy gold wholesale direct, gold price today',
//     });
//   }

//   private setupRouterEvents(): void {
//     this.router.events
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((event: any) => {
//         if (event instanceof NavigationEnd) {
//           window.scrollTo(0, 0);
//         }
//       });
//   }

//   private setupWebSocket(): void {
//     this.spotGoldUpdate = 0;
//     this.spotSilverUpdate = 0;
//     this.previousSpotGoldUpdate = 0;
//     this.previousSpotINRUpdate = 0;
//     this.previousSpotSilverUpdate = 0;

//     this.spotGoldColor = '#e1b737';
//     this.spotSilverColor = '#e1b737';
//     this.spotINRColor = '#e1b737';

//     this.socketSubscription = this.webSocketService
//       .startFetching()
//       .pipe(
//         debounceTime(500),
//         takeUntil(this.destroy$)
//       )
//       .subscribe({
//         next: (message: string) => {
//           this.handleWebSocketMessage(message);
//         },
//         error: (error: any) => {
//           console.error('WebSocket error:', error);
//         }
//       });
//   }

//   private startTimeUpdates(): void {
//     this.timeSubscription = interval(1000)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(() => {
//         this.updateTime();
//       });
//   }

//   // Add these methods to your HomeService class (inside the class, not in the component)

// /**
//  * Get rates with filtering options for chart
//  * @param metal - 'gold' or 'silver'
//  * @param duration - 'day', 'week', 'month', 'year'
//  * @param interval - 'hourly', 'daily', 'weekly', 'monthly'
//  * @param gap - gap between data points
//  */
// getRates(metal: string, duration?: string, interval?: string, gap?: number) {
//   let url = `/api/live-rates?metal=${metal}`;
//   if (duration) url += `&duration=${duration}`;
//   if (interval) url += `&interval=${interval}`;
//   if (gap) url += `&gap=${gap}`;
  
//   return this.http.get(url);
// }

// /**
//  * Get statistics for a metal (High/Low data)
//  * @param metal - 'gold' or 'silver'
//  * @param period - 'day', 'week', 'month', 'year'
//  */
// getStatistics(metal: string, period: string) {
//   return this.http.get(`/api/live-stats?metal=${metal}&period=${period}`);
// }

//   updateTime(): void {
//     this.now = new Date();
//   }

//   isWeekend(): void {
//     this.now = new Date();
//     const day = this.now.toLocaleString('en-us', { weekday: 'short' });
//     const isWeekend = day === 'Sat' || day === 'Sun';

//     if (this.kyc_status !== 2) {
//       this.treding = !isWeekend;
//       this.isWeekendDay = isWeekend;
//     } else {
//       this.treding = true;
//       this.isWeekendDay = false;
//     }
//   }

//   checkTime(): void {
//     const now = new Date();
//     const currentHour = now.getHours();
//     const currentMinute = now.getMinutes();
//     const currentDay = now.getDay();

//     const isBefore930AM =
//       currentHour < 9 || (currentHour === 9 && currentMinute < 30);
//     const isAfter1130PM =
//       currentHour > 23 || (currentHour === 23 && currentMinute >= 30);
//     const isWeekday = currentDay >= 1 && currentDay <= 5;

//     this.shouldShowAlert = (isBefore930AM || isAfter1130PM) && isWeekday;
//   }

//   /**
//    * Get token from any available storage key
//    */
//   private getToken(): string | null {
//     for (const key of this.TOKEN_KEYS) {
//       const token = localStorage.getItem(key);
//       if (token && token !== 'undefined' && token !== 'null') {
//         return token;
//       }
//     }
//     return null;
//   }

//   /**
//    * Get user data safely
//    */
//   private getUserData(): any {
//     const userDataString = localStorage.getItem('userData');
//     if (!userDataString || userDataString === 'undefined' || userDataString === 'null') {
//       return null;
//     }

//     try {
//       return JSON.parse(userDataString);
//     } catch {
//       return null;
//     }
//   }

//   checkLoginAndTime(): void {
//     const token = this.getToken();
//     this.isLogin = !!token;
//     console.log('Is logged in:', this.isLogin);

//     const now = new Date();
//     const currentHour = now.getHours();
//     const currentMinute = now.getMinutes();

//     const isRestrictedTime = (currentHour === 23 && currentMinute >= 30) ||
//       (currentHour >= 0 && currentHour < 9) ||
//       (currentHour === 9 && currentMinute < 30);

//     this.isNotAllowedTime = !isRestrictedTime;

//     if (this.isLogin && this.isNotAllowedTime) {
//       this.userProfile();
//     }
//   }

//   // Gold amount validation
//   userAmount(userInput: any): void {
//     if (userInput) {
//       const livePrice = parseFloat(this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate);
//       const enteredAmount = parseFloat(userInput);
      
//       // Check if it's a valid number
//       if (isNaN(enteredAmount)) {
//         this.isAmountLessThan110 = false;
//         return;
//       }
      
//       // Calculate difference (live price - entered amount)
//       const difference = livePrice - enteredAmount;
      
//       console.log('Gold validation:', {
//         livePrice,
//         enteredAmount,
//         difference,
//         isValid: difference >= 0 && difference <= 110
//       });
      
//       // Valid if:
//       // 1. Entered amount is not higher than live price (difference >= 0)
//       // 2. Difference is within 110 rupees (difference <= 110)
//       if (difference >= 0 && difference <= 110) {
//         this.isAmountLessThan110 = true;
//       } else {
//         this.isAmountLessThan110 = false;
        
//         if (enteredAmount > livePrice) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
//             position: 'topCenter',
//           });
//         } else if (difference > 110) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Amount too low. Must be within ₹110 of locked price. Minimum allowed: ₹${(livePrice - 110).toFixed(2)}`,
//             position: 'topCenter',
//           });
//         }
//       }
//     }
//   }

//   // Silver amount validation
//   userAmountSilver(userInput: any): void {
//     if (userInput) {
//       const livePrice = parseFloat(this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate);
//       const enteredAmount = parseFloat(userInput);
      
//       if (isNaN(enteredAmount)) {
//         this.isAmountLessThan1000 = false;
//         return;
//       }
      
//       const difference = livePrice - enteredAmount;
      
//       console.log('Silver validation:', {
//         livePrice,
//         enteredAmount,
//         difference,
//         isValid: difference >= 0 && difference <= 1000
//       });
      
//       if (difference >= 0 && difference <= 1000) {
//         this.isAmountLessThan1000 = true;
//       } else {
//         this.isAmountLessThan1000 = false;
        
//         if (enteredAmount > livePrice) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
//             position: 'topCenter',
//           });
//         } else if (difference > 1000) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Amount too low. Must be within ₹1000 of locked price. Minimum allowed: ₹${(livePrice - 1000).toFixed(2)}`,
//             position: 'topCenter',
//           });
//         }
//       }
//     }
//   }

//   checkLogIn(): void {
//     this.toast.warning({
//       detail: 'Login Required!',
//       summary: 'Please login for book gold',
//       position: 'topCenter',
//     });
//   }

//   // Method to lock the price
//   lockPrice(type: string): void {
//     // Clear any existing lock timer
//     if (this.lockInterval) {
//       clearInterval(this.lockInterval);
//     }
    
//     // Set locked prices
//     if (type === 'Gold') {
//       this.lockedGoldPrice = this.stayBuyGoldRate;
//     } else {
//       this.lockedSilverPrice = this.stayBuySilverRate;
//     }

    
//     this.priceLocked = true;
//     this.lockTimer = 30;
    
//     // Start countdown
//     this.lockInterval = setInterval(() => {
//       this.lockTimer--;
      
//       if (this.lockTimer <= 0) {
//         this.unlockPrice();
//       }
//     }, 1000);
    
//     console.log(`Price locked for ${type} at ${type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice} for 30 seconds`);
//   const lockData = {
//     type: type,
//     lockedPrice: type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice,
//     timer: this.lockTimer,
//     lockedAt: new Date().toISOString()
//   };

//   localStorage.setItem('lockedPriceData', JSON.stringify(lockData));

//   console.log(lockData.lockedPrice,'newwwwwwwLocked');
//   }

//   // Method to unlock the price
//   unlockPrice(): void {
//     this.priceLocked = false;
//     this.lockedGoldPrice = null;
//     this.lockedSilverPrice = null;
//     this.lockTimer = 0;
    
//     if (this.lockInterval) {
//       clearInterval(this.lockInterval);
//       this.lockInterval = null;
//     }
    
//     console.log('Price unlocked');
//   }

//   // Updated buy submit with price locking
//   onBuySubmit(value: string): void {
//     const token = this.getToken();
//     if (!token) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to make a purchase',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       return;
//     }

//     // Check if price is locked for this type
//     if (value === 'Gold' && !this.lockedGoldPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Buy button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }
    
//     if (value === 'Silver' && !this.lockedSilverPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Buy button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }

//     if (!this.buyGoldForm.valid) {
//       this.toast.warning({
//         detail: 'Invalid Form',
//         summary: 'Please fill all required fields',
//         position: 'topCenter',
//       });
//       return;
//     }

//     const quantity = this.buyGoldForm.get('quantity_purchased')?.value;
//     if (!quantity) {
//       this.toast.warning({
//         detail: 'Quantity Required',
//         summary: 'Please select a quantity',
//         position: 'topCenter',
//       });
//       return;
//     }

//     // Use locked price instead of live price
//     const price = value === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice;
    
//     // Format price for backend
//     const formattedPrice = value === 'Gold' 
//       ? Math.floor(parseFloat(price)).toString() 
//       : parseFloat(price).toFixed(2);

//     const orderData = {
//       product_name: value,
//       quantity_purchased: quantity.toString(),
//       purchased_price: formattedPrice,
//       order_type: value
//     };

//     console.log('Sending order data with locked price:', orderData);

//     this.spinner.show();

//     this.home.buyGoldAnsSilver(orderData)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.spinner.hide();
//           this.toast.success({
//             detail: 'Success!',
//             summary: res.msg || 'Order placed successfully',
//             position: 'topCenter',
//           });
//           this.buyGoldForm.reset();
//           this.unlockPrice(); // Unlock price after successful purchase
//           this.goldLimit();
//           this.silverLimit();

          
//           setTimeout(() => {
//     this.router.navigate(['/orders']);
//   }, 1000);
//         },
//         error: (err: any) => {
//           this.spinner.hide();
//           console.error('Order error:', err);
//           if (err.status === 401) {
//             this.handleSessionExpired();
//           } else {
//             this.toast.error({
//               detail: 'Oops!',
//               summary: err.error?.msg || 'Something went wrong',
//               position: 'topCenter',
//             });
//           }
//         }
//       });
//   }

//   // Updated gold submit with price locking
//   onGoldSubmit(value: string): void {
//     const token = this.getToken();
//     if (!token) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to book gold/silver',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       return;
//     }

//     // Check if price is locked
//     if (value === 'gold' && !this.lockedGoldPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Book button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }
    
//     if (value === 'silver' && !this.lockedSilverPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Book button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }

//     const form = value === 'gold' ? this.bookGoldForm : this.bookSilverForm;

//     if (!form.valid) {
//       this.toast.warning({
//         detail: 'Invalid Form',
//         summary: 'Please fill all required fields',
//         position: 'topCenter',
//       });
//       return;
//     }

//     const quantity = form.get('quantity_purchased')?.value;
//     const bookRate = form.get('book_rate')?.value;
    
//     if (!quantity || !bookRate) {
//       this.toast.warning({
//         detail: 'Missing Information',
//         summary: 'Please select quantity and enter amount',
//         position: 'topCenter',
//       });
//       return;
//     }

//     // Use locked price for validation
//     const livePrice = value === 'gold' 
//       ? parseFloat(this.lockedGoldPrice) 
//       : parseFloat(this.lockedSilverPrice);
      
//     const enteredAmount = parseFloat(bookRate);
//     const difference = livePrice - enteredAmount;
    
//     if (value === 'gold' && (difference < 0 || difference > 110)) {
//       this.toast.warning({
//         detail: 'Invalid Amount',
//         summary: `Amount must be between ₹${(livePrice - 110).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
//         position: 'topCenter',
//       });
//       return;
//     }
    
//     if (value === 'silver' && (difference < 0 || difference > 1000)) {
//       this.toast.warning({
//         detail: 'Invalid Amount',
//         summary: `Amount must be between ₹${(livePrice - 1000).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
//         position: 'topCenter',
//       });
//       return;
//     }

//     const bookingData = {
//       product_name: value === 'gold' ? 'Gold' : 'Silver',
//       quantity_purchased: quantity.toString(),
//       book_rate: bookRate.toString(),
//       order_type: value === 'gold' ? 'Gold' : 'Silver'
//     };

//     console.log('Sending booking data with locked price:', bookingData);

//     this.spinner.show();

//     this.home.bookGoldAndSilver(bookingData)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.spinner.hide();
//           this.toast.success({
//             detail: 'Success!',
//             summary: res.msg || 'Booking successful',
//             position: 'topCenter',
//           });
//           form.reset();
//           // Reset with defaults
//           if (value === 'gold') {
//             this.bookGoldForm.patchValue({
//               product_name: 'Gold',
//               order_type: 'Gold'
//             });
//           } else {
//             this.bookSilverForm.patchValue({
//               product_name: 'Silver',
//               order_type: 'Silver'
//             });
//           }
//           this.unlockPrice(); // Unlock price after successful booking
//           this.goldLimit();
//           this.silverLimit();
//         },
//         error: (err: any) => {
//           this.spinner.hide();
//           console.error('Booking error:', err);
//           this.toast.error({
//             detail: 'Error!',
//             summary: err.error?.msg || 'Something went wrong',
//             position: 'topCenter',
//           });
//         }
//       });
//   }

//   openDialog(): void {
//     this.dialog.open(PopupDialogComponent, {
//       width: '500px',
//       panelClass: 'custom-dialog-container',
//     });
//   }

//   private handleWebSocketMessage(message: string): void {
//     this.data = message;

//     if (!message || message === 'undefined' || message === 'null' || message.trim() === '' || message.length < 2) {
//       return;
//     }

//     try {
//       if (message.startsWith('42')) {
//         const jsonStr = message.substring(2);
        
//         if (!jsonStr || jsonStr.trim() === '' || jsonStr === 'undefined') {
//           return;
//         }
        
//         const jsonMessage = JSON.parse(jsonStr);
        
//         if (!Array.isArray(jsonMessage) || jsonMessage.length < 2) {
//           return;
//         }

//         const priceData = jsonMessage[1];
//         if (!priceData || !priceData.updatedata) {
//           return;
//         }

//         const eventData = priceData.updatedata;
//         if (eventData === 'undefined' || !eventData) {
//           return;
//         }

//         const jsonData = JSON.parse(eventData);
//         const dataArray = Array.isArray(jsonData) ? jsonData : [jsonData];
        
//         const filteredData = dataArray.filter(
//           (item: any) => item?.gold1_symbol && 
//           ['SPOT-INR', 'SPOT-SILVER', 'SPOT-GOLD'].includes(item.gold1_symbol)
//         );

//         if (filteredData.length >= 3) {
//           filteredData.forEach((item: any) => {
//             switch(item.gold1_symbol) {
//               case 'SPOT-GOLD':
//                 this.spotGold = item.gold1_ask;
//                 break;
//               case 'SPOT-SILVER':
//                 this.spotSilver = item.gold1_ask;
//                 break;
//               case 'SPOT-INR':
//                 this.spotINR = item.gold1_ask;
//                 break;
//             }
//           });
          
//           // Only update stayBuy rates if price is not locked
//           if (!this.priceLocked) {
//             this.fetchPremiums();
//           }
//         }
//       }
//     } catch (error) {
//       // Silent fail
//     }
//   }

//   private filterData(data: any[]): any[] {
//     return data.filter(
//       (item: any) =>
//         item.gold1_symbol === 'SPOT-INR' ||
//         item.gold1_symbol === 'SPOT-SILVER' ||
//         item.gold1_symbol === 'SPOT-GOLD'
//     );
//   }

//   private fetchPremiums(): void {
//     this.http.get('https://liverates-api.goldcentral.in/api/getpremium')
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           if (res?.premium !== undefined) {
//             this.primium = res.premium;
//             this.fetchSilverPremium();
//           }
//         },
//         error: (error: any) => {
//           console.error('Error fetching premium:', error);
//         }
//       });
//   }

//   private fetchSilverPremium(): void {
//     this.http.get('https://liverates-api.goldcentral.in/api/getSilverPremium')
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           if (res?.premium !== undefined) {
//             this.silverPrimium = res.premium;
//             this.calculateUpdatedPrices();
//           }
//         },
//         error: (error: any) => {
//           console.error('Error fetching silver premium:', error);
//         }
//       });
//   }

//   private calculateUpdatedPrices(): void {
//     const ozToGrams = 31.102;
//     const GOV_GOLD_TAX = 6.25;
//     const GOV_SILVER_TAX = 6.75;
//     const GST_TAX_PERCENTAGE = 0;

//     const totalChargesPercentage = GOV_GOLD_TAX + GST_TAX_PERCENTAGE;

//     // Gold price calculation
//     const checkGold1 = this.spotGold / ozToGrams;
//     const INRrupeeGold = checkGold1 * this.spotINR;
//     let convGold: number = (INRrupeeGold / 100) * totalChargesPercentage + INRrupeeGold;
//     convGold += (convGold * this.primium) / 100;
//     this.spotGoldUpdate = convGold.toFixed(2);
    
//     // Only update stayBuyGoldRate if price is not locked
//     if (!this.priceLocked || !this.lockedGoldPrice) {
//       this.stayBuyGoldRate = this.spotGoldUpdate;
//     }

//     // Silver price calculation
//     const checkSilver = (this.spotSilver / 31.1) * this.spotINR * 1000;
//     const inrSilver = checkSilver + (checkSilver / 100) * GOV_SILVER_TAX;
//     const finalSilver = inrSilver + (inrSilver * this.silverPrimium) / 1000;
//     this.spotSilverUpdate = (finalSilver + 100).toFixed(2);
    
//     // Only update stayBuySilverRate if price is not locked
//     if (!this.priceLocked || !this.lockedSilverPrice) {
//       this.stayBuySilverRate = this.spotSilverUpdate;
//     }

//     this.updatePriceColors();
//   }

//   private updatePriceColors(): void {
//     this.spotGoldColor = this.getColor(this.spotGoldUpdate, this.previousSpotGoldUpdate);
//     this.spotINRColor = this.getColor(this.spotINR, this.previousSpotINRUpdate);
//     this.spotSilverColor = this.getColor(this.spotSilverUpdate, this.previousSpotSilverUpdate);

//     setTimeout(() => {
//       this.previousSpotGoldUpdate = this.spotGoldUpdate;
//       this.previousSpotSilverUpdate = this.spotSilverUpdate;
//       this.previousSpotINRUpdate = this.spotINR;
//     }, 100);
//   }

//   private getColor(current: number | string, previous: number | string): string {
//     const currentNum = typeof current === 'string' ? parseFloat(current) : current;
//     const previousNum = typeof previous === 'string' ? parseFloat(previous) : previous;

//     if (currentNum > previousNum) return '#FE4A54';
//     if (currentNum < previousNum) return '#76f590';
//     return '#e1b737';
//   }

//   public isWeekendCheck(): boolean {
//     const currentDay = new Date().getDay();
//     return currentDay === 0 || currentDay === 6;
//   }

//   // Updated callLimit with price locking
//   callLimit(value: string): void {
//     this.newgoldcard=true;
//     const token = this.getToken();
//     if (!token) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to view limits',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       return;
//     }

//     // Lock the price when button is clicked
//     this.lockPrice(value);

//     if (value === 'Gold') {
//       this.goldLimit();
//       this.timerBuy = 30;
//       this.startTimer();
//     } else {
//       this.silverLimit();
//       this.timerBuy = 30;
//       this.startTimer();
//     }
//   }

//   callLimitt(){
//   this.newgoldcard=true;
// }

//   goldLimit(): void {
//     this.home.getGoldLimit()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.goldMaxLimit = res.maxLimitValues;
//         },
//         error: (err: any) => {
//           if (err.status === 401) {
//             this.handleSessionExpired();
//           } else {
//             console.error('Error fetching gold limit:', err);
//           }
//         }
//       });
//   }

//   silverLimit(): void {
//     this.home.getSilverLimit()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.silverMaxLimit = res.silverMaxLimitValues;
//         },
//         error: (err: any) => {
//           if (err.status === 401) {
//             this.handleSessionExpired();
//           } else {
//             console.error('Error fetching silver limit:', err);
//           }
//         }
//       });
//   }

//   userProfile(): void {
//     const token = this.getToken();
//     if (!token) {
//       console.log('No token found, user not logged in');
//       this.isLogin = false;
//       return;
//     }

//     this.auth.userDetailGet()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           if (res.success) {
//             const data = res.data;
//             this.profileDetails = data.userData;
//             this.kyc_status = data.kyc_status;

//             if (data.userData) {
//               const userDataToStore = {
//                 id: data.userData?.id,
//                 kyc_status: data.kyc_status,
//                 ...data.userData
//               };
//               localStorage.setItem('userData', JSON.stringify(userDataToStore));
//             }

//             if (data.token) {
//               const newToken = data.token.startsWith('Bearer ') ? data.token : `Bearer ${data.token}`;
//               localStorage.setItem('user-access', newToken);
//             }

//             this.getTimingsbyId();
//             this.tryOpenPendingProductModal();
//           }
//         },
//         error: (err: any) => {
//           if (err.status === 401) {
//             console.error('Session expired:', err);
//             this.handleSessionExpired();
//           } else {
//             console.error('Error fetching user profile:', err);
//           }
//         }
//       });
//   }

//   private handleSessionExpired(): void {
//     this.TOKEN_KEYS.forEach(key => localStorage.removeItem(key));
//     localStorage.removeItem('userData');
//     localStorage.removeItem('user-details-goldBharat');

//     this.isLogin = false;
//     this.kyc_status = null;
//     this.profileDetails = null;

//     this.toast.warning({
//       detail: 'Session Expired',
//       summary: 'Please login again to continue',
//       duration: 3000,
//       position: 'topCenter'
//     });

//     this.router.navigate(['/login']);
//   }

//   getWhatsAppLink(number: string): string {
//     const formattedNumber = number.replace(/\D/g, '');
//     return `https://wa.me/${formattedNumber}`;
//   }

//   getTimingsbyId(): void {
//     const userData = this.getUserData();

//     if (!userData) {
//       console.log('User data not found in localStorage');
//       return;
//     }
//     if (!userData?.id) {
//       console.error('User ID not found in user data');
//       if (this.isLogin) {
//         this.userProfile();
//       }
//       return;
//     }

//     const token = this.getToken();
//     if (!token) {
//       console.log('No token found, skipping timings fetch');
//       return;
//     }

//     if (userData.kyc_status !== 0 && userData.kyc_status !== undefined) {
//       this.home.getTimings(userData.id)
//         .pipe(
//           takeUntil(this.destroy$),
//           catchError(err => {
//             if (err.status === 401) {
//               this.handleSessionExpired();
//             }
//             return of(null);
//           })
//         )
//         .subscribe({
//           next: (response: any) => {
//             if (response) {
//               this.timingsData = response;
//               console.log('Timings loaded:', this.timingsData);
//             }
//           }
//         });
//     }
//   }

//   goldSilverRateStay(): void {
//     this.home.getInitialRates()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (data: any) => {
//           if (data) {
//             // Only update if price is not locked
//             if (!this.priceLocked || !this.lockedGoldPrice) {
//               this.stayBuyGoldRate = data.carat24?.sell_price_per_gram;
                 
//             }
     
//             if (!this.priceLocked || !this.lockedSilverPrice) {
//               this.stayBuySilverRate = data.silverPrice?.sell_price_per_gram;
//             }
//           }
//         },
//         error: (err: any) => {
//           console.error('Error fetching rates:', err);
//         }
//       });
//   }

//   startTimer(): void {
//     this.stopTimer();

//     this.timerSubscriptionBuy = interval(1000)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(() => {
//         this.timerBuy--;
//         if (this.timerBuy <= 0) {
//           this.timerBuy = 30;
//           // Don't reload the page, just refresh rates if not locked
//           if (!this.priceLocked) {
//             this.goldSilverRateStay();
//           }
//         }
//       });
//   }

//   stopTimer(): void {
//     if (this.timerSubscriptionBuy) {
//       this.timerSubscriptionBuy.unsubscribe();
//       this.timerSubscriptionBuy = null;
//     }
//   }

//   // Updated closeModal to unlock price
// closeModal(): void {
//   this.stopTimer();
//   this.unlockPrice();
//   this.selectedOption = null;

//   const openModalEl = document.querySelector('.modal.show') as HTMLElement | null;

//   if (openModalEl) {
//     const modalInstance = bootstrap.Modal.getOrCreateInstance(openModalEl);

//     // fade transition పూర్తయ్యాకే cleanup run అవ్వాలి
//     openModalEl.addEventListener('hidden.bs.modal', () => {
//       this.forceClearAllBackdrops();
//     }, { once: true });

//     modalInstance.hide();

//     // safety net: ఎప్పుడైనా 'hidden.bs.modal' event fire అవ్వకపోతే (rare edge case),
//     // 400ms తర్వాత force గా backdrop క్లియర్ చేయాలి
//     setTimeout(() => {
//       this.forceClearAllBackdrops();
//     }, 400);

//   } else {
//     // ఏ modal.show దొరక్కపోయినా, migిలిన backdrop ఏదైనా unte force clear
//     this.forceClearAllBackdrops();
//   }
// }

// // private forceClearAllBackdrops(): void {
// //   const openModals = document.querySelectorAll('.modal.show');

// //   if (openModals.length === 0) {
// //     document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
// //     document.body.classList.remove('modal-open');
// //     document.body.style.removeProperty('overflow');
// //     document.body.style.removeProperty('padding-right');
// //   }
// // }

// forceClearAllBackdrops(): void {

//   document.querySelectorAll('.modal-backdrop').forEach((el: any) => {
//     el.remove();
//   });

//   document.querySelectorAll('.modal').forEach((modal: any) => {
//     modal.classList.remove('show');
//     modal.setAttribute('aria-hidden', 'true');
//     modal.style.display = 'none';
//   });

//   document.body.classList.remove('modal-open');
//   document.body.style.removeProperty('overflow');
//   document.body.style.removeProperty('padding-right');

// }
// switchToBuyGoldModal(): void {
//   const currentModalEl = document.getElementById('buyGoldModalNew');
//   const currentModal = bootstrap.Modal.getInstance(currentModalEl!);

//   currentModalEl?.addEventListener('hidden.bs.modal', () => {
//     this.clearModalBackdrop(); 
//     const nextModalEl = document.getElementById('buyGoldModal');
//     const nextModal = new bootstrap.Modal(nextModalEl!);
//     nextModal.show();
//   }, { once: true });

//   currentModal?.hide();
//   this.selectedOption = 'bars';
// }

// // switchToBuyGoldModalsilver(): void {
// //   const currentModalEl = document.getElementById('buyGoldModalNewSilver');
// //   const currentModal = bootstrap.Modal.getOrCreateInstance(currentModalEl!);

// //   currentModalEl?.addEventListener('hidden.bs.modal', () => {
// //     this.clearModalBackdrop();
// //     const nextModalEl = document.getElementById('buySilverModal');
// //     const nextModal = bootstrap.Modal.getOrCreateInstance(nextModalEl!);  
// //     nextModal.show();
// //   }, { once: true });

// //   currentModal.hide();
// //   this.selectedOption = 'bars';
// // }

// switchToBuyGoldModalsilver(): void {
//   const currentModalEl = document.getElementById('buyGoldModalNewSilver');
//   const currentModal = bootstrap.Modal.getOrCreateInstance(currentModalEl!);

//   currentModalEl?.addEventListener('hidden.bs.modal', () => {
//     this.forceClearAllBackdrops();
//     const nextModalEl = document.getElementById('buySilverModal');
//     const nextModal = bootstrap.Modal.getOrCreateInstance(nextModalEl!);
//     nextModal.show();
//   }, { once: true });

//   currentModal.hide();
//   this.selectedOption = 'bars';
// }

// private clearModalBackdrop(): void {
//   const openModals = document.querySelectorAll('.modal.show');
//   const backdrops = document.querySelectorAll('.modal-backdrop');

//   if (openModals.length === 0 && backdrops.length > 0) {
//     document.body.classList.remove('modal-open');
//     document.body.style.removeProperty('overflow');
//     document.body.style.removeProperty('padding-right');
//     backdrops.forEach(el => el.remove());
//   }
// }
//   ngOnDestroy(): void {
//     this.destroy$.next();
//     this.destroy$.complete();

//     this.stopTimer();
    
//     // Clear lock interval
//     if (this.lockInterval) {
//       clearInterval(this.lockInterval);
//     }

//     if (this.timeSubscription) {
//       this.timeSubscription.unsubscribe();
//     }

//     if (this.socketSubscription) {
//       this.socketSubscription.unsubscribe();
//     }
//   }

//   // Helper methods to get valid ranges
//   getValidGoldRange(): string {
//     const price = this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate;
//     if (price) {
//       const livePrice = parseFloat(price);
//       const minPrice = (livePrice - 110).toFixed(2);
//       return `₹${minPrice} - ₹${livePrice.toFixed(2)}`;
//     }
//     return '';
//   }

//   getValidSilverRange(): string {
//     const price = this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate;
//     if (price) {
//       const livePrice = parseFloat(price);
//       const minPrice = (livePrice - 1000).toFixed(2);
//       return `₹${minPrice} - ₹${livePrice.toFixed(2)}`;
//     }
//     return '';
//   }




//   selectedOption: 'coins' | 'bars' | null = null;
// lockSeconds = 28;
// private timerInterval: any;

// // selectOption(option: 'coins' | 'bars'): void {
// //   this.selectedOption = option;

// //   if (option === 'coins') {
// //     const modalEl = document.getElementById('buyGoldModalNew');
// //     const modalInstance = bootstrap.Modal.getInstance(modalEl!);

// //     modalEl?.addEventListener('hidden.bs.modal', () => {
// //       this.router.navigate(['/gold-coins']);
// //     }, { once: true });

// //     modalInstance?.hide();
// //   }
// // }

// selectOption(
//   option: 'coins' | 'bars',
//   metalType: 'Gold' | 'Silver'
// ): void {

//   this.selectedOption = option;

//   const modalId =
//     metalType === 'Gold'
//       ? 'buyGoldModalNew'
//       : 'buyGoldModalNewSilver';

//   const modalEl = document.getElementById(modalId);

//   const modalInstance = bootstrap.Modal.getInstance(modalEl!);

// modalEl?.addEventListener(
//   'hidden.bs.modal',
//   () => {

//     this.forceClearAllBackdrops();

//     this.router.navigate(['/gold-coins'], {
//       queryParams: {
//         metalType
//       }
//     });

//   },
//   { once: true }
// );

//   modalInstance?.hide();
// }

// startPriceLockTimer() {
//   this.timerInterval = setInterval(() => {
//     if (this.lockSeconds > 0) {
//       this.lockSeconds--;
//     } else {
//       clearInterval(this.timerInterval);
//       // price refresh or modal close logic ikkada add cheyandi
//     }
//   }, 1000);
// }

// // ngOnDestroy() {
// //   if (this.timerInterval) clearInterval(this.timerInterval);
// // }

// progress = 0;
// showScrollButton = false;

// @HostListener('window:scroll')
// onScroll() {

//   const scrollTop = window.scrollY;

//   const scrollHeight =
//     document.documentElement.scrollHeight -
//     document.documentElement.clientHeight;

//   this.progress =
//     scrollHeight > 0
//       ? (scrollTop / scrollHeight) * 100
//       : 0;

//   this.showScrollButton = scrollTop > 50;
// }

// scrollToTop() {
//   window.scrollTo({
//     top: 0,
//     behavior: 'smooth'
//   });
// }

// private handlePendingProductModal(): void {
//   if (!this.pendingProductModal) return;

//   if (!this.isLogin) {
//     this.toast.warning({
//       detail: 'Login Required',
//       summary: 'Please login to continue',
//       position: 'topCenter',
//     });
//     this.router.navigate(['/login']);
//     this.pendingProductModal = null;
//     return;
//   }

//   if (this.kyc_status !== undefined && this.kyc_status !== null) {
//     this.tryOpenPendingProductModal();
//   }
// }

// private tryOpenPendingProductModal(): void {
//   if (!this.pendingProductModal) return;
//   if (this.kyc_status === undefined || this.kyc_status === null) return;

//   const type = this.pendingProductModal;
//   this.pendingProductModal = null;
//   const metal: 'Gold' | 'Silver' = type === 'gold' ? 'Gold' : 'Silver';

//   if (this.kyc_status === 2) {
//     this.callLimit(metal);
//     const modalId = metal === 'Gold' ? 'buyGoldModalNew' : 'buyGoldModalNewSilver';
//     this.openModalById(modalId);
//   } else if (this.kyc_status === 0) {
//     this.openModalById('updateKyx');
//   } else if (this.kyc_status === 1) {
//     this.openModalById('Kyxpending');
//   } else if (this.kyc_status === 3) {
//     this.openModalById('Kyxrejected');
//   }
// }

// private openModalById(id: string): void {
//   const el = document.getElementById(id);
//   if (el) {
//     bootstrap.Modal.getOrCreateInstance(el).show();
//     return;
//   }
//   setTimeout(() => {
//     const retryEl = document.getElementById(id);
//     if (retryEl) {
//       bootstrap.Modal.getOrCreateInstance(retryEl).show();
//     }
//   }, 300);
// }
// }


// import { Component, ElementRef, ViewChild, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
// import * as bootstrap from 'bootstrap';
// import { HomeService } from '../services/home.service';
// import { Subscription, debounceTime, interval, Subject, takeUntil, forkJoin, of } from 'rxjs';
// import { WebSocketService } from '../services/web-socket.service';
// import { NgToastService } from 'ng-angular-popup';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { HttpClient } from '@angular/common/http';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import { AuthService } from '../services/auth.service';
// import { MatDialog } from '@angular/material/dialog';
// import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';
// import { ConfigService } from '../services/config.service';
// import { Meta, Title } from '@angular/platform-browser';
// import { catchError } from 'rxjs/operators';
// import { HostListener } from '@angular/core';
// import {
//   Chart,
//   LineElement,
//   PointElement,
//   LineController,
//   CategoryScale,
//   LinearScale,
//   Filler,
//   Tooltip,
//   Legend,
//   ChartConfiguration,
// } from 'chart.js';

// // Register only what we need (tree-shakeable)
// Chart.register(
//   LineElement,
//   PointElement,
//   LineController,
//   CategoryScale,
//   LinearScale,
//   Filler,
//   Tooltip,
//   Legend
// );

// @Component({
//   selector: 'app-homepage',
//   templateUrl: './homepage.component.html',
//   styleUrls: ['./homepage.component.scss'],
// })
// export class HomepageComponent implements OnInit, AfterViewInit, OnDestroy {
//   @ViewChild('exampleModalGold', { static: false }) modalElement!: ElementRef;

//   showDiv = {
//     previous: true,
//     current: true,
//     next: true,
//   };

//   livePrice: any;
//   spotGold: any;
//   spotSilver: any;
//   spotINR: any;
//   primium: any = 0;
//   spotGoldUpdate: any;
//   spotSilverUpdate: any;
//   isGold: boolean = true;
//   previousSpotSilverUpdate: any;
//   spotSilverColor: string = '#e1b737';
//   isLogin: any;
//   isNotAllowedTime: boolean = true;
//   fAmount!: number;

//   // Forms
//   buyGoldForm: FormGroup;
//   bookSilverForm: FormGroup;
//   bookGoldForm: FormGroup;

//   isTotal: boolean = false;
//   isAmountLessThan110: boolean = false;
//   isAmountLessThan1000: boolean = false;
//   goldMaxLimit: any;
//   silverMaxLimit: any;
//   kyc_status: any;
//   silverPrimium: any = 0;
//   treding: boolean = false;
//   isWeekendDay: boolean = false;
//   phoneNumbers: string[] = [];
//   timings: string = '';
//   whatsappNumber: string = '';
//   email: string = '';
//   address: string = '';
//   companyname: any;
//   backGroundColor: any;
//   colorChangeTimeout: any;
//   usrID: any;
//   profileDetails: any;
//   timingsData: any;
//   shouldShowAlert: boolean = false;
//   buySilverRate: any;
//   buyGoldRate: any;

//   timerBuy: number = 30;
//   timerSubscriptionBuy: Subscription | null = null;
//   stayBuyGoldRate: any;
//   stayBuySilverRate: any;

//   now: Date = new Date();

//   previousSpotGoldUpdate: any = 0;
//   previousSpotINRUpdate: any = 0;
//   spotGoldColor: string = '#e1b737';
//   spotINRColor: string = '#e1b737';
//   data: string | undefined;

//   // Price locking properties
//   priceLocked: boolean = false;
//   lockedGoldPrice: any = null;
//   lockedSilverPrice: any = null;
//   lockTimer: number = 0;
//   lockInterval: any = null;
//   newgoldcard: boolean = false;
//   private destroy$ = new Subject<void>();
//   private timeSubscription: Subscription | undefined;
//   public socketSubscription: Subscription | undefined;
//   public livePriceSubscription: Subscription | undefined;

//   // Token keys to check
//   private readonly TOKEN_KEYS = [
//     'user-access',
//     'token',
//     'user-token-goldBharatFirst'
//   ];

//   // ─── Product-page → Homepage popup deep link ──────────────────────────────
//   // Set from ?openModal=gold|silver query param, consumed once login/KYC are known
//   private pendingProductModal: 'gold' | 'silver' | null = null;
//   // ────────────────────────────────────────────────────────────────────────

//   // ─── CHART & H/L PROPERTIES (merged from mobileview) ──────────────────────
//   goldDayHigh: number = 0;
//   goldDayLow: number = 999999;
//   silverDayHigh: number = 0;
//   silverDayLow: number = 999999;
//   goldChangePercent: number = 0;
//   silverChangePercent: number = 0;
//   selectedTimeframe: string = 'today';

//   private goldPriceHistory: { time: string; price: number }[] = [];
//   private silverPriceHistory: { time: string; price: number }[] = [];
//   private trendChart: Chart | null = null;
//   private goldOpenPrice: number = 0;
//   private silverOpenPrice: number = 0;
//   private chartInitialized: boolean = false;
//   // ─────────────────────────────────────────────────────────────────────────

//   constructor(
//     private home: HomeService,
//     private webSocketService: WebSocketService,
//     private toast: NgToastService,
//     private spinner: NgxSpinnerService,
//     private http: HttpClient,
//     private fb: FormBuilder,
//     private router: Router,
//     private route: ActivatedRoute,
//     private auth: AuthService,
//     public dialog: MatDialog,
//     private configService: ConfigService,
//     private meta: Meta,
//     private titleService: Title
//   ) {
//     // Initialize forms with correct names and default values
//     this.bookGoldForm = this.fb.group({
//       product_name: ['Gold'],
//       quantity_purchased: ['', [Validators.required]],
//       book_rate: [
//         '',
//         [
//           Validators.required,
//           Validators.pattern('^\\d*\\.?\\d*$'),
//         ],
//       ],
//       order_type: ['Gold'],
//     });

//     this.bookSilverForm = this.fb.group({
//       product_name: ['Silver'],
//       quantity_purchased: ['', [Validators.required]],
//       book_rate: [
//         '',
//         [
//           Validators.required,
//           Validators.pattern('^\\d*\\.?\\d*$'),
//         ],
//       ],
//       order_type: ['Silver'],
//     });

//     this.buyGoldForm = this.fb.group({
//       product_name: [''],
//       quantity_purchased: ['', [Validators.required]],
//       purchased_price: [''],
//       order_type: [''],
//     });
//   }

//   ngOnInit(): void {
//     this.home.getInitialRates().subscribe((res: any) => {
//       console.log(res);

//       this.spotGoldUpdate = res.carat24.sell_price_per_gram;
//       this.spotSilverUpdate = res.silverPrice.sell_price_per_gram;
//     });

//     // Capture ?openModal=gold|silver coming from the products page
//     this.route.queryParams
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(params => {
//         if (params['openModal'] === 'gold' || params['openModal'] === 'silver') {
//           this.pendingProductModal = params['openModal'];
//         }
//       });

//     this.initializeComponent();

//     const modalIds = ['buyGoldModalNewSilver', 'buySilverModal', 'buyGoldModalNew', 'buyGoldModal'];
//   }

//   ngAfterViewInit(): void {
//     const modalIds = ['buyGoldModalNew', 'buyGoldModal', 'bookGoldModal', 'buySilverModal', 'bookSilverModal'];

//     modalIds.forEach(id => {
//       const modalEl = document.getElementById(id);
//       modalEl?.addEventListener('hidden.bs.modal', () => {
//         this.clearModalBackdrop();
//       });
//     });

//     // Chart canvas is ready; if we already have data, render immediately
//     if (this.goldPriceHistory.length > 0) {
//       this.updateTrendChart();
//     }
//   }

//   private initializeComponent(): void {
//     // Clean up any corrupted data first
//     this.cleanupLocalStorage();

//     // Initialize in parallel where possible
//     forkJoin({
//       config: this.loadConfigSafe(),
//       initialRates: this.home.getInitialRates().pipe(catchError(() => of(null)))
//     }).subscribe({
//       next: (results) => {
//         if (results.config) {
//           this.applyConfig(results.config);
//         }
//         if (results.initialRates) {
//           this.handleInitialRates(results.initialRates);
//         }
//       },
//       complete: () => {
//         // These don't depend on each other
//         this.checkLoginAndTime();
//         this.checkTime();
//         this.setMetaTags();
//         this.setupRouterEvents();
//         this.setupWebSocket();
//         this.startTimeUpdates();
//         this.isWeekend();

//         // Deep-link from products page: try to open the requested popup
//         this.handlePendingProductModal();
//       }
//     });
//   }

//   /**
//    * Clean up corrupted localStorage data
//    */
//   private cleanupLocalStorage(): void {
//     // Remove any 'undefined' string values
//     const keysToCheck = ['userData', 'user-details-goldBharat', 'user-token-goldBharatFirst'];
//     keysToCheck.forEach(key => {
//       const value = localStorage.getItem(key);
//       if (value === 'undefined' || value === 'null') {
//         localStorage.removeItem(key);
//       }
//     });

//     // Validate userData JSON
//     const userDataString = localStorage.getItem('userData');
//     if (userDataString) {
//       try {
//         JSON.parse(userDataString);
//       } catch {
//         // Corrupted JSON, remove it
//         localStorage.removeItem('userData');
//       }
//     }
//   }

//   /**
//    * Safely load config
//    */
//   private loadConfigSafe() {
//     return this.configService.loadConfig().pipe(
//       catchError(error => {
//         console.error('Error loading config:', error);
//         return of(null);
//       })
//     );
//   }

//   /**
//    * Apply config data
//    */
//   private applyConfig(config: any): void {
//     if (config?.contact) {
//       this.phoneNumbers = config.contact.phoneNumbers || [];
//       this.timings = config.contact.timings || '';
//       this.whatsappNumber = config.contact.whatsappNumber || '';
//       this.email = config.contact.email || '';
//       this.address = config.contact.address || '';
//       this.companyname = config.company?.companyname || '';
//       this.backGroundColor = config.company;
//     }
//   }

//   /**
//    * Handle initial rates
//    */
//   private handleInitialRates(data: any): void {
//     if (data) {
//       this.spotGoldUpdate = data.carat24?.sell_price_per_gram;
//       this.spotSilverUpdate = data.silverPrice?.sell_price_per_gram;
//       this.spotGold = data.carat24?.spot_gold;
//       this.spotSilver = data.silverPrice?.spot_silver;
//       this.spotINR = data.carat24?.spot_inr;

//       // Set initial buy rates
//       this.stayBuyGoldRate = this.spotGoldUpdate;
//       this.stayBuySilverRate = this.spotSilverUpdate;

//       console.log('Initial rates loaded:', {
//         gold: this.spotGoldUpdate,
//         silver: this.spotSilverUpdate
//       });

//       // Seed H/L and trend chart with initial rates
//       this.recordPriceHistory();
//     }
//   }

//   private setMetaTags(): void {
//     this.titleService.setTitle('Buy Gold & Silver In Bulk At Best Price | Goldbharat');

//     this.meta.updateTag({
//       name: 'description',
//       content: 'Buy bulk gold and silver at unbeatable prices. Secure your wealth with high-quality precious metals, ideal for investors seeking long-term reliability and value protection.',
//     });

//     this.meta.updateTag({
//       name: 'keywords',
//       content: 'buy gold wholesale, buy gold in bulk, buy gold wholesale direct, gold price today',
//     });
//   }

//   private setupRouterEvents(): void {
//     this.router.events
//       .pipe(takeUntil(this.destroy$))
//       .subscribe((event: any) => {
//         if (event instanceof NavigationEnd) {
//           window.scrollTo(0, 0);
//         }
//       });
//   }

//   private setupWebSocket(): void {
//     this.spotGoldUpdate = 0;
//     this.spotSilverUpdate = 0;
//     this.previousSpotGoldUpdate = 0;
//     this.previousSpotINRUpdate = 0;
//     this.previousSpotSilverUpdate = 0;

//     this.spotGoldColor = '#e1b737';
//     this.spotSilverColor = '#e1b737';
//     this.spotINRColor = '#e1b737';

//     this.socketSubscription = this.webSocketService
//       .startFetching()
//       .pipe(
//         debounceTime(500),
//         takeUntil(this.destroy$)
//       )
//       .subscribe({
//         next: (message: string) => {
//           this.handleWebSocketMessage(message);
//         },
//         error: (error: any) => {
//           console.error('WebSocket error:', error);
//         }
//       });
//   }

//   private startTimeUpdates(): void {
//     this.timeSubscription = interval(1000)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(() => {
//         this.updateTime();
//       });
//   }

//   /**
//    * Get rates with filtering options for chart
//    * @param metal - 'gold' or 'silver'
//    * @param duration - 'day', 'week', 'month', 'year'
//    * @param interval - 'hourly', 'daily', 'weekly', 'monthly'
//    * @param gap - gap between data points
//    */
//   getRates(metal: string, duration?: string, interval?: string, gap?: number) {
//     let url = `/api/live-rates?metal=${metal}`;
//     if (duration) url += `&duration=${duration}`;
//     if (interval) url += `&interval=${interval}`;
//     if (gap) url += `&gap=${gap}`;

//     return this.http.get(url);
//   }

//   /**
//    * Get statistics for a metal (High/Low data)
//    * @param metal - 'gold' or 'silver'
//    * @param period - 'day', 'week', 'month', 'year'
//    */
//   getStatistics(metal: string, period: string) {
//     return this.http.get(`/api/live-stats?metal=${metal}&period=${period}`);
//   }

//   updateTime(): void {
//     this.now = new Date();
//   }

//   isWeekend(): void {
//     this.now = new Date();
//     const day = this.now.toLocaleString('en-us', { weekday: 'short' });
//     const isWeekend = day === 'Sat' || day === 'Sun';

//     if (this.kyc_status !== 2) {
//       this.treding = !isWeekend;
//       this.isWeekendDay = isWeekend;
//     } else {
//       this.treding = true;
//       this.isWeekendDay = false;
//     }
//   }

//   checkTime(): void {
//     const now = new Date();
//     const currentHour = now.getHours();
//     const currentMinute = now.getMinutes();
//     const currentDay = now.getDay();

//     const isBefore930AM =
//       currentHour < 9 || (currentHour === 9 && currentMinute < 30);
//     const isAfter1130PM =
//       currentHour > 23 || (currentHour === 23 && currentMinute >= 30);
//     const isWeekday = currentDay >= 1 && currentDay <= 5;

//     this.shouldShowAlert = (isBefore930AM || isAfter1130PM) && isWeekday;
//   }

//   /**
//    * Get token from any available storage key
//    */
//   private getToken(): string | null {
//     for (const key of this.TOKEN_KEYS) {
//       const token = localStorage.getItem(key);
//       if (token && token !== 'undefined' && token !== 'null') {
//         return token;
//       }
//     }
//     return null;
//   }

//   /**
//    * Get user data safely
//    */
//   private getUserData(): any {
//     const userDataString = localStorage.getItem('userData');
//     if (!userDataString || userDataString === 'undefined' || userDataString === 'null') {
//       return null;
//     }

//     try {
//       return JSON.parse(userDataString);
//     } catch {
//       return null;
//     }
//   }

//   checkLoginAndTime(): void {
//     const token = this.getToken();
//     this.isLogin = !!token;
//     console.log('Is logged in:', this.isLogin);

//     const now = new Date();
//     const currentHour = now.getHours();
//     const currentMinute = now.getMinutes();

//     const isRestrictedTime = (currentHour === 23 && currentMinute >= 30) ||
//       (currentHour >= 0 && currentHour < 9) ||
//       (currentHour === 9 && currentMinute < 30);

//     this.isNotAllowedTime = !isRestrictedTime;

//     if (this.isLogin && this.isNotAllowedTime) {
//       this.userProfile();
//     }
//   }

//   // Gold amount validation
//   userAmount(userInput: any): void {
//     if (userInput) {
//       const livePrice = parseFloat(this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate);
//       const enteredAmount = parseFloat(userInput);

//       // Check if it's a valid number
//       if (isNaN(enteredAmount)) {
//         this.isAmountLessThan110 = false;
//         return;
//       }

//       // Calculate difference (live price - entered amount)
//       const difference = livePrice - enteredAmount;

//       console.log('Gold validation:', {
//         livePrice,
//         enteredAmount,
//         difference,
//         isValid: difference >= 0 && difference <= 110
//       });

//       // Valid if:
//       // 1. Entered amount is not higher than live price (difference >= 0)
//       // 2. Difference is within 110 rupees (difference <= 110)
//       if (difference >= 0 && difference <= 110) {
//         this.isAmountLessThan110 = true;
//       } else {
//         this.isAmountLessThan110 = false;

//         if (enteredAmount > livePrice) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
//             position: 'topCenter',
//           });
//         } else if (difference > 110) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Amount too low. Must be within ₹110 of locked price. Minimum allowed: ₹${(livePrice - 110).toFixed(2)}`,
//             position: 'topCenter',
//           });
//         }
//       }
//     }
//   }

//   // Silver amount validation
//   userAmountSilver(userInput: any): void {
//     if (userInput) {
//       const livePrice = parseFloat(this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate);
//       const enteredAmount = parseFloat(userInput);

//       if (isNaN(enteredAmount)) {
//         this.isAmountLessThan1000 = false;
//         return;
//       }

//       const difference = livePrice - enteredAmount;

//       console.log('Silver validation:', {
//         livePrice,
//         enteredAmount,
//         difference,
//         isValid: difference >= 0 && difference <= 1000
//       });

//       if (difference >= 0 && difference <= 1000) {
//         this.isAmountLessThan1000 = true;
//       } else {
//         this.isAmountLessThan1000 = false;

//         if (enteredAmount > livePrice) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
//             position: 'topCenter',
//           });
//         } else if (difference > 1000) {
//           this.toast.warning({
//             detail: 'Invalid Amount',
//             summary: `Amount too low. Must be within ₹1000 of locked price. Minimum allowed: ₹${(livePrice - 1000).toFixed(2)}`,
//             position: 'topCenter',
//           });
//         }
//       }
//     }
//   }

//   checkLogIn(): void {
//     this.toast.warning({
//       detail: 'Login Required!',
//       summary: 'Please login for book gold',
//       position: 'topCenter',
//     });
//   }

//   // Method to lock the price
//   lockPrice(type: string): void {
//     // Clear any existing lock timer
//     if (this.lockInterval) {
//       clearInterval(this.lockInterval);
//     }

//     // Set locked prices
//     if (type === 'Gold') {
//       this.lockedGoldPrice = this.stayBuyGoldRate;
//     } else {
//       this.lockedSilverPrice = this.stayBuySilverRate;
//     }

//     this.priceLocked = true;
//     this.lockTimer = 30;

//     // Start countdown
//     this.lockInterval = setInterval(() => {
//       this.lockTimer--;

//       if (this.lockTimer <= 0) {
//         this.unlockPrice();
//       }
//     }, 1000);

//     console.log(`Price locked for ${type} at ${type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice} for 30 seconds`);
//     const lockData = {
//       type: type,
//       lockedPrice: type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice,
//       timer: this.lockTimer,
//       lockedAt: new Date().toISOString()
//     };

//     localStorage.setItem('lockedPriceData', JSON.stringify(lockData));

//     console.log(lockData.lockedPrice, 'newwwwwwwLocked');
//   }

//   // Method to unlock the price
//   unlockPrice(): void {
//     this.priceLocked = false;
//     this.lockedGoldPrice = null;
//     this.lockedSilverPrice = null;
//     this.lockTimer = 0;

//     if (this.lockInterval) {
//       clearInterval(this.lockInterval);
//       this.lockInterval = null;
//     }

//     console.log('Price unlocked');
//   }

//   // Updated buy submit with price locking
//   onBuySubmit(value: string): void {
//     const token = this.getToken();
//     if (!token) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to make a purchase',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       return;
//     }

//     // Check if price is locked for this type
//     if (value === 'Gold' && !this.lockedGoldPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Buy button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }

//     if (value === 'Silver' && !this.lockedSilverPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Buy button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }

//     if (!this.buyGoldForm.valid) {
//       this.toast.warning({
//         detail: 'Invalid Form',
//         summary: 'Please fill all required fields',
//         position: 'topCenter',
//       });
//       return;
//     }

//     const quantity = this.buyGoldForm.get('quantity_purchased')?.value;
//     if (!quantity) {
//       this.toast.warning({
//         detail: 'Quantity Required',
//         summary: 'Please select a quantity',
//         position: 'topCenter',
//       });
//       return;
//     }

//     // Use locked price instead of live price
//     const price = value === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice;

//     // Format price for backend
//     const formattedPrice = value === 'Gold'
//       ? Math.floor(parseFloat(price)).toString()
//       : parseFloat(price).toFixed(2);

//     const orderData = {
//       product_name: value,
//       quantity_purchased: quantity.toString(),
//       purchased_price: formattedPrice,
//       order_type: value
//     };

//     console.log('Sending order data with locked price:', orderData);

//     this.spinner.show();

//     this.home.buyGoldAnsSilver(orderData)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.spinner.hide();
//           this.toast.success({
//             detail: 'Success!',
//             summary: res.msg || 'Order placed successfully',
//             position: 'topCenter',
//           });
//           this.buyGoldForm.reset();
//           this.unlockPrice(); // Unlock price after successful purchase
//           this.goldLimit();
//           this.silverLimit();

//           setTimeout(() => {
//             this.router.navigate(['/orders']);
//           }, 1000);
//         },
//         error: (err: any) => {
//           this.spinner.hide();
//           console.error('Order error:', err);
//           if (err.status === 401) {
//             this.handleSessionExpired();
//           } else {
//             this.toast.error({
//               detail: 'Oops!',
//               summary: err.error?.msg || 'Something went wrong',
//               position: 'topCenter',
//             });
//           }
//         }
//       });
//   }

//   // Updated gold submit with price locking
//   onGoldSubmit(value: string): void {
//     const token = this.getToken();
//     if (!token) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to book gold/silver',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       return;
//     }

//     // Check if price is locked
//     if (value === 'gold' && !this.lockedGoldPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Book button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }

//     if (value === 'silver' && !this.lockedSilverPrice) {
//       this.toast.warning({
//         detail: 'Price Expired',
//         summary: 'Please click on Book button again to refresh the price',
//         position: 'topCenter',
//       });
//       return;
//     }

//     const form = value === 'gold' ? this.bookGoldForm : this.bookSilverForm;

//     if (!form.valid) {
//       this.toast.warning({
//         detail: 'Invalid Form',
//         summary: 'Please fill all required fields',
//         position: 'topCenter',
//       });
//       return;
//     }

//     const quantity = form.get('quantity_purchased')?.value;
//     const bookRate = form.get('book_rate')?.value;

//     if (!quantity || !bookRate) {
//       this.toast.warning({
//         detail: 'Missing Information',
//         summary: 'Please select quantity and enter amount',
//         position: 'topCenter',
//       });
//       return;
//     }

//     // Use locked price for validation
//     const livePrice = value === 'gold'
//       ? parseFloat(this.lockedGoldPrice)
//       : parseFloat(this.lockedSilverPrice);

//     const enteredAmount = parseFloat(bookRate);
//     const difference = livePrice - enteredAmount;

//     if (value === 'gold' && (difference < 0 || difference > 110)) {
//       this.toast.warning({
//         detail: 'Invalid Amount',
//         summary: `Amount must be between ₹${(livePrice - 110).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
//         position: 'topCenter',
//       });
//       return;
//     }

//     if (value === 'silver' && (difference < 0 || difference > 1000)) {
//       this.toast.warning({
//         detail: 'Invalid Amount',
//         summary: `Amount must be between ₹${(livePrice - 1000).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
//         position: 'topCenter',
//       });
//       return;
//     }

//     const bookingData = {
//       product_name: value === 'gold' ? 'Gold' : 'Silver',
//       quantity_purchased: quantity.toString(),
//       book_rate: bookRate.toString(),
//       order_type: value === 'gold' ? 'Gold' : 'Silver'
//     };

//     console.log('Sending booking data with locked price:', bookingData);

//     this.spinner.show();

//     this.home.bookGoldAndSilver(bookingData)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.spinner.hide();
//           this.toast.success({
//             detail: 'Success!',
//             summary: res.msg || 'Booking successful',
//             position: 'topCenter',
//           });
//           form.reset();
//           // Reset with defaults
//           if (value === 'gold') {
//             this.bookGoldForm.patchValue({
//               product_name: 'Gold',
//               order_type: 'Gold'
//             });
//           } else {
//             this.bookSilverForm.patchValue({
//               product_name: 'Silver',
//               order_type: 'Silver'
//             });
//           }
//           this.unlockPrice(); // Unlock price after successful booking
//           this.goldLimit();
//           this.silverLimit();
//         },
//         error: (err: any) => {
//           this.spinner.hide();
//           console.error('Booking error:', err);
//           this.toast.error({
//             detail: 'Error!',
//             summary: err.error?.msg || 'Something went wrong',
//             position: 'topCenter',
//           });
//         }
//       });
//   }

//   openDialog(): void {
//     this.dialog.open(PopupDialogComponent, {
//       width: '500px',
//       panelClass: 'custom-dialog-container',
//     });
//   }

//   private handleWebSocketMessage(message: string): void {
//     this.data = message;

//     if (!message || message === 'undefined' || message === 'null' || message.trim() === '' || message.length < 2) {
//       return;
//     }

//     try {
//       if (message.startsWith('42')) {
//         const jsonStr = message.substring(2);

//         if (!jsonStr || jsonStr.trim() === '' || jsonStr === 'undefined') {
//           return;
//         }

//         const jsonMessage = JSON.parse(jsonStr);

//         if (!Array.isArray(jsonMessage) || jsonMessage.length < 2) {
//           return;
//         }

//         const priceData = jsonMessage[1];
//         if (!priceData || !priceData.updatedata) {
//           return;
//         }

//         const eventData = priceData.updatedata;
//         if (eventData === 'undefined' || !eventData) {
//           return;
//         }

//         const jsonData = JSON.parse(eventData);
//         const dataArray = Array.isArray(jsonData) ? jsonData : [jsonData];

//         const filteredData = dataArray.filter(
//           (item: any) => item?.gold1_symbol &&
//             ['SPOT-INR', 'SPOT-SILVER', 'SPOT-GOLD'].includes(item.gold1_symbol)
//         );

//         if (filteredData.length >= 3) {
//           filteredData.forEach((item: any) => {
//             switch (item.gold1_symbol) {
//               case 'SPOT-GOLD':
//                 this.spotGold = item.gold1_ask;
//                 break;
//               case 'SPOT-SILVER':
//                 this.spotSilver = item.gold1_ask;
//                 break;
//               case 'SPOT-INR':
//                 this.spotINR = item.gold1_ask;
//                 break;
//             }
//           });

//           // Only update stayBuy rates if price is not locked
//           if (!this.priceLocked) {
//             this.fetchPremiums();
//           }
//         }
//       }
//     } catch (error) {
//       // Silent fail
//     }
//   }

//   private filterData(data: any[]): any[] {
//     return data.filter(
//       (item: any) =>
//         item.gold1_symbol === 'SPOT-INR' ||
//         item.gold1_symbol === 'SPOT-SILVER' ||
//         item.gold1_symbol === 'SPOT-GOLD'
//     );
//   }

//   private fetchPremiums(): void {
//     this.http.get('https://liverates-api.goldcentral.in/api/getpremium')
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           if (res?.premium !== undefined) {
//             this.primium = res.premium;
//             this.fetchSilverPremium();
//           }
//         },
//         error: (error: any) => {
//           console.error('Error fetching premium:', error);
//         }
//       });
//   }

//   private fetchSilverPremium(): void {
//     this.http.get('https://liverates-api.goldcentral.in/api/getSilverPremium')
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           if (res?.premium !== undefined) {
//             this.silverPrimium = res.premium;
//             this.calculateUpdatedPrices();
//           }
//         },
//         error: (error: any) => {
//           console.error('Error fetching silver premium:', error);
//         }
//       });
//   }

//   private calculateUpdatedPrices(): void {
//     const ozToGrams = 31.102;
//     const GOV_GOLD_TAX = 6.25;
//     const GOV_SILVER_TAX = 6.75;
//     const GST_TAX_PERCENTAGE = 0;

//     const totalChargesPercentage = GOV_GOLD_TAX + GST_TAX_PERCENTAGE;

//     // Gold price calculation
//     const checkGold1 = this.spotGold / ozToGrams;
//     const INRrupeeGold = checkGold1 * this.spotINR;
//     let convGold: number = (INRrupeeGold / 100) * totalChargesPercentage + INRrupeeGold;
//     convGold += (convGold * this.primium) / 100;
//     this.spotGoldUpdate = convGold.toFixed(2);

//     // Only update stayBuyGoldRate if price is not locked
//     if (!this.priceLocked || !this.lockedGoldPrice) {
//       this.stayBuyGoldRate = this.spotGoldUpdate;
//     }

//     // Silver price calculation
//     const checkSilver = (this.spotSilver / 31.1) * this.spotINR * 1000;
//     const inrSilver = checkSilver + (checkSilver / 100) * GOV_SILVER_TAX;
//     const finalSilver = inrSilver + (inrSilver * this.silverPrimium) / 1000;
//     this.spotSilverUpdate = (finalSilver + 100).toFixed(2);

//     // Only update stayBuySilverRate if price is not locked
//     if (!this.priceLocked || !this.lockedSilverPrice) {
//       this.stayBuySilverRate = this.spotSilverUpdate;
//     }

//     this.updatePriceColors();
//     this.recordPriceHistory(); // ← update chart & H/L on every price tick
//   }

//   private updatePriceColors(): void {
//     this.spotGoldColor = this.getColor(this.spotGoldUpdate, this.previousSpotGoldUpdate);
//     this.spotINRColor = this.getColor(this.spotINR, this.previousSpotINRUpdate);
//     this.spotSilverColor = this.getColor(this.spotSilverUpdate, this.previousSpotSilverUpdate);

//     setTimeout(() => {
//       this.previousSpotGoldUpdate = this.spotGoldUpdate;
//       this.previousSpotSilverUpdate = this.spotSilverUpdate;
//       this.previousSpotINRUpdate = this.spotINR;
//     }, 100);
//   }

//   private getColor(current: number | string, previous: number | string): string {
//     const currentNum = typeof current === 'string' ? parseFloat(current) : current;
//     const previousNum = typeof previous === 'string' ? parseFloat(previous) : previous;

//     if (currentNum > previousNum) return '#FE4A54';
//     if (currentNum < previousNum) return '#76f590';
//     return '#e1b737';
//   }

//   public isWeekendCheck(): boolean {
//     const currentDay = new Date().getDay();
//     return currentDay === 0 || currentDay === 6;
//   }

//   // Updated callLimit with price locking
//   callLimit(value: string): void {
//     this.newgoldcard = true;
//     const token = this.getToken();
//     if (!token) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to view limits',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       return;
//     }

//     // Lock the price when button is clicked
//     this.lockPrice(value);

//     if (value === 'Gold') {
//       this.goldLimit();
//       this.timerBuy = 30;
//       this.startTimer();
//     } else {
//       this.silverLimit();
//       this.timerBuy = 30;
//       this.startTimer();
//     }
//   }

//   callLimitt() {
//     this.newgoldcard = true;
//   }

//   goldLimit(): void {
//     this.home.getGoldLimit()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.goldMaxLimit = res.maxLimitValues;
//         },
//         error: (err: any) => {
//           if (err.status === 401) {
//             this.handleSessionExpired();
//           } else {
//             console.error('Error fetching gold limit:', err);
//           }
//         }
//       });
//   }

//   silverLimit(): void {
//     this.home.getSilverLimit()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           this.silverMaxLimit = res.silverMaxLimitValues;
//         },
//         error: (err: any) => {
//           if (err.status === 401) {
//             this.handleSessionExpired();
//           } else {
//             console.error('Error fetching silver limit:', err);
//           }
//         }
//       });
//   }

//   userProfile(): void {
//     const token = this.getToken();
//     if (!token) {
//       console.log('No token found, user not logged in');
//       this.isLogin = false;
//       return;
//     }

//     this.auth.userDetailGet()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (res: any) => {
//           if (res.success) {
//             const data = res.data;
//             this.profileDetails = data.userData;
//             this.kyc_status = data.kyc_status;

//             if (data.userData) {
//               const userDataToStore = {
//                 id: data.userData?.id,
//                 kyc_status: data.kyc_status,
//                 ...data.userData
//               };
//               localStorage.setItem('userData', JSON.stringify(userDataToStore));
//             }

//             if (data.token) {
//               const newToken = data.token.startsWith('Bearer ') ? data.token : `Bearer ${data.token}`;
//               localStorage.setItem('user-access', newToken);
//             }

//             this.getTimingsbyId();

//             // KYC status just became known — resolve any pending deep-linked modal
//             this.tryOpenPendingProductModal();
//           }
//         },
//         error: (err: any) => {
//           if (err.status === 401) {
//             console.error('Session expired:', err);
//             this.handleSessionExpired();
//           } else {
//             console.error('Error fetching user profile:', err);
//           }
//         }
//       });
//   }

//   private handleSessionExpired(): void {
//     this.TOKEN_KEYS.forEach(key => localStorage.removeItem(key));
//     localStorage.removeItem('userData');
//     localStorage.removeItem('user-details-goldBharat');

//     this.isLogin = false;
//     this.kyc_status = null;
//     this.profileDetails = null;

//     this.toast.warning({
//       detail: 'Session Expired',
//       summary: 'Please login again to continue',
//       duration: 3000,
//       position: 'topCenter'
//     });

//     this.router.navigate(['/login']);
//   }

//   getWhatsAppLink(number: string): string {
//     const formattedNumber = number.replace(/\D/g, '');
//     return `https://wa.me/${formattedNumber}`;
//   }

//   getTimingsbyId(): void {
//     const userData = this.getUserData();

//     if (!userData) {
//       console.log('User data not found in localStorage');
//       return;
//     }
//     if (!userData?.id) {
//       console.error('User ID not found in user data');
//       if (this.isLogin) {
//         this.userProfile();
//       }
//       return;
//     }

//     const token = this.getToken();
//     if (!token) {
//       console.log('No token found, skipping timings fetch');
//       return;
//     }

//     if (userData.kyc_status !== 0 && userData.kyc_status !== undefined) {
//       this.home.getTimings(userData.id)
//         .pipe(
//           takeUntil(this.destroy$),
//           catchError(err => {
//             if (err.status === 401) {
//               this.handleSessionExpired();
//             }
//             return of(null);
//           })
//         )
//         .subscribe({
//           next: (response: any) => {
//             if (response) {
//               this.timingsData = response;
//               console.log('Timings loaded:', this.timingsData);
//             }
//           }
//         });
//     }
//   }

//   goldSilverRateStay(): void {
//     this.home.getInitialRates()
//       .pipe(takeUntil(this.destroy$))
//       .subscribe({
//         next: (data: any) => {
//           if (data) {
//             // Only update if price is not locked
//             if (!this.priceLocked || !this.lockedGoldPrice) {
//               this.stayBuyGoldRate = data.carat24?.sell_price_per_gram;
//             }

//             if (!this.priceLocked || !this.lockedSilverPrice) {
//               this.stayBuySilverRate = data.silverPrice?.sell_price_per_gram;
//             }
//           }
//         },
//         error: (err: any) => {
//           console.error('Error fetching rates:', err);
//         }
//       });
//   }

//   startTimer(): void {
//     this.stopTimer();

//     this.timerSubscriptionBuy = interval(1000)
//       .pipe(takeUntil(this.destroy$))
//       .subscribe(() => {
//         this.timerBuy--;
//         if (this.timerBuy <= 0) {
//           this.timerBuy = 30;
//           // Don't reload the page, just refresh rates if not locked
//           if (!this.priceLocked) {
//             this.goldSilverRateStay();
//           }
//         }
//       });
//   }

//   stopTimer(): void {
//     if (this.timerSubscriptionBuy) {
//       this.timerSubscriptionBuy.unsubscribe();
//       this.timerSubscriptionBuy = null;
//     }
//   }

//   // Updated closeModal to unlock price
//   closeModal(): void {
//     this.stopTimer();
//     this.unlockPrice();
//     this.selectedOption = null;

//     const openModalEl = document.querySelector('.modal.show') as HTMLElement | null;

//     if (openModalEl) {
//       const modalInstance = bootstrap.Modal.getOrCreateInstance(openModalEl);

//       // fade transition పూర్తయ్యాకే cleanup run అవ్వాలి
//       openModalEl.addEventListener('hidden.bs.modal', () => {
//         this.forceClearAllBackdrops();
//       }, { once: true });

//       modalInstance.hide();

//       // safety net: ఎప్పుడైనా 'hidden.bs.modal' event fire అవ్వకపోతే (rare edge case),
//       // 400ms తర్వాత force గా backdrop క్లియర్ చేయాలి
//       setTimeout(() => {
//         this.forceClearAllBackdrops();
//       }, 400);

//     } else {
//       // ఏ modal.show దొరక్కపోయినా, migిలిన backdrop ఏదైనా unte force clear
//       this.forceClearAllBackdrops();
//     }
//   }

//   forceClearAllBackdrops(): void {

//     document.querySelectorAll('.modal-backdrop').forEach((el: any) => {
//       el.remove();
//     });

//     document.querySelectorAll('.modal').forEach((modal: any) => {
//       modal.classList.remove('show');
//       modal.setAttribute('aria-hidden', 'true');
//       modal.style.display = 'none';
//     });

//     document.body.classList.remove('modal-open');
//     document.body.style.removeProperty('overflow');
//     document.body.style.removeProperty('padding-right');

//   }
//   switchToBuyGoldModal(): void {
//     const currentModalEl = document.getElementById('buyGoldModalNew');
//     const currentModal = bootstrap.Modal.getInstance(currentModalEl!);

//     currentModalEl?.addEventListener('hidden.bs.modal', () => {
//       this.clearModalBackdrop();
//       const nextModalEl = document.getElementById('buyGoldModal');
//       const nextModal = new bootstrap.Modal(nextModalEl!);
//       nextModal.show();
//     }, { once: true });

//     currentModal?.hide();
//     this.selectedOption = 'bars';
//   }

//   switchToBuyGoldModalsilver(): void {
//     const currentModalEl = document.getElementById('buyGoldModalNewSilver');
//     const currentModal = bootstrap.Modal.getOrCreateInstance(currentModalEl!);

//     currentModalEl?.addEventListener('hidden.bs.modal', () => {
//       this.forceClearAllBackdrops();
//       const nextModalEl = document.getElementById('buySilverModal');
//       const nextModal = bootstrap.Modal.getOrCreateInstance(nextModalEl!);
//       nextModal.show();
//     }, { once: true });

//     currentModal.hide();
//     this.selectedOption = 'bars';
//   }

//   private clearModalBackdrop(): void {
//     const openModals = document.querySelectorAll('.modal.show');
//     const backdrops = document.querySelectorAll('.modal-backdrop');

//     if (openModals.length === 0 && backdrops.length > 0) {
//       document.body.classList.remove('modal-open');
//       document.body.style.removeProperty('overflow');
//       document.body.style.removeProperty('padding-right');
//       backdrops.forEach(el => el.remove());
//     }
//   }

//   // ─── CHART & H/L METHODS (merged from mobileview) ──────────────────────────

//   /**
//    * Called after every price calculation tick (and once on initial rates).
//    * Records a new data point and updates H/L, % change, and the chart.
//    */
//   private recordPriceHistory(): void {
//     const goldPrice = parseFloat(this.spotGoldUpdate);
//     const silverPrice = parseFloat(this.spotSilverUpdate);

//     if (!goldPrice || !silverPrice || isNaN(goldPrice) || isNaN(silverPrice)) return;

//     // Set open price (first seen price of the session)
//     if (this.goldOpenPrice === 0) this.goldOpenPrice = goldPrice;
//     if (this.silverOpenPrice === 0) this.silverOpenPrice = silverPrice;

//     // Update Day High / Low
//     if (goldPrice > this.goldDayHigh) this.goldDayHigh = goldPrice;
//     if (goldPrice < this.goldDayLow) this.goldDayLow = goldPrice;
//     if (silverPrice > this.silverDayHigh) this.silverDayHigh = silverPrice;
//     if (silverPrice < this.silverDayLow) this.silverDayLow = silverPrice;

//     // Change % vs session open
//     this.goldChangePercent = ((goldPrice - this.goldOpenPrice) / this.goldOpenPrice) * 100;
//     this.silverChangePercent = ((silverPrice - this.silverOpenPrice) / this.silverOpenPrice) * 100;

//     // Time label
//     const now = new Date();
//     const timeLabel = now.toLocaleTimeString('en-IN', {
//       hour: '2-digit',
//       minute: '2-digit',
//     });

//     // Append & cap at 60 points (≈ 1 point every WebSocket tick, ~30 min of data)
//     this.goldPriceHistory.push({ time: timeLabel, price: goldPrice });
//     this.silverPriceHistory.push({ time: timeLabel, price: silverPrice });

//     if (this.goldPriceHistory.length > 60) this.goldPriceHistory.shift();
//     if (this.silverPriceHistory.length > 60) this.silverPriceHistory.shift();

//     this.updateTrendChart();
//   }

//   /**
//    * Creates or updates the Chart.js line chart.
//    */
//   private updateTrendChart(): void {
//     const canvas = document.getElementById('trendChart') as HTMLCanvasElement | null;
//     if (!canvas) return;

//     const labels = this.goldPriceHistory.map(p => p.time);
//     const goldData = this.goldPriceHistory.map(p => p.price);
//     const silverData = this.silverPriceHistory.map(p => p.price);

//     // If the chart already exists, just push new data without re-creating it
//     if (this.trendChart) {
//       this.trendChart.data.labels = labels;
//       this.trendChart.data.datasets[0].data = goldData;
//       this.trendChart.data.datasets[1].data = silverData;
//       this.trendChart.update('none'); // 'none' skips animation for performance
//       return;
//     }

//     // First-time creation
//     const config: ChartConfiguration<'line'> = {
//       type: 'line',
//       data: {
//         labels,
//         datasets: [
//           {
//             label: 'Gold (₹/g)',
//             data: goldData,
//             borderColor: '#e1b737',
//             backgroundColor: 'rgba(225,183,55,0.12)',
//             borderWidth: 2,
//             pointRadius: 0,
//             pointHoverRadius: 4,
//             fill: true,
//             tension: 0.4,
//             yAxisID: 'yGold',
//           },
//           {
//             label: 'Silver (₹/kg)',
//             data: silverData,
//             borderColor: '#a8aab1',
//             backgroundColor: 'rgba(168,170,177,0.06)',
//             borderWidth: 2,
//             pointRadius: 0,
//             pointHoverRadius: 4,
//             fill: false,
//             tension: 0.4,
//             yAxisID: 'ySilver',
//           },
//         ],
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         animation: { duration: 0 },
//         interaction: { mode: 'index', intersect: false },
//         plugins: {
//           legend: { display: false },
//           tooltip: {
//             backgroundColor: '#030F55',
//             titleColor: '#a0a8c8',
//             bodyColor: '#ffffff',
//             borderColor: '#464E8A',
//             borderWidth: 1,
//             padding: 10,
//             callbacks: {
//               label: (ctx) => {
//                 const val = ctx.parsed.y;
//                 return ctx.datasetIndex === 0
//                   ? ` Gold: ₹${(val ?? 0).toFixed(2)}/g`
//                   : ` Silver: ₹${(val ?? 0).toFixed(2)}/kg`;
//               },
//             },
//           },
//         },
//         scales: {
//           x: {
//             ticks: {
//               color: '#a0a8c8',
//               maxTicksLimit: 6,
//               font: { size: 10 },
//             },
//             grid: { color: 'rgba(255,255,255,0.05)' },
//           },
//           yGold: {
//             position: 'left',
//             ticks: { color: '#e1b737', font: { size: 10 } },
//             grid: { color: 'rgba(255,255,255,0.05)' },
//           },
//           ySilver: {
//             position: 'right',
//             ticks: { color: '#a8aab1', font: { size: 10 } },
//             grid: { drawOnChartArea: false },
//           },
//         },
//       },
//     };

//     this.trendChart = new Chart(canvas, config);
//     this.chartInitialized = true;
//   }

//   /**
//    * Called when the timeframe dropdown changes.
//    * Resets history and destroys the current chart so it rebuilds fresh.
//    */
//   onTimeframeChange(): void {
//     this.goldPriceHistory = [];
//     this.silverPriceHistory = [];
//     this.goldOpenPrice = 0;
//     this.silverOpenPrice = 0;
//     this.goldDayHigh = 0;
//     this.goldDayLow = 999999;
//     this.silverDayHigh = 0;
//     this.silverDayLow = 999999;
//     this.goldChangePercent = 0;
//     this.silverChangePercent = 0;

//     if (this.trendChart) {
//       this.trendChart.destroy();
//       this.trendChart = null;
//     }
//   }

//   // ─────────────────────────────────────────────────────────────────────────

//   ngOnDestroy(): void {
//     this.destroy$.next();
//     this.destroy$.complete();

//     this.stopTimer();

//     // Clear lock interval
//     if (this.lockInterval) {
//       clearInterval(this.lockInterval);
//     }

//     if (this.timeSubscription) {
//       this.timeSubscription.unsubscribe();
//     }

//     if (this.socketSubscription) {
//       this.socketSubscription.unsubscribe();
//     }

//     // Destroy chart to prevent memory leak
//     if (this.trendChart) {
//       this.trendChart.destroy();
//       this.trendChart = null;
//     }
//   }

//   // Helper methods to get valid ranges
//   getValidGoldRange(): string {
//     const price = this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate;
//     if (price) {
//       const livePrice = parseFloat(price);
//       const minPrice = (livePrice - 110).toFixed(2);
//       return `₹${minPrice} - ₹${livePrice.toFixed(2)}`;
//     }
//     return '';
//   }

//   getValidSilverRange(): string {
//     const price = this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate;
//     if (price) {
//       const livePrice = parseFloat(price);
//       const minPrice = (livePrice - 1000).toFixed(2);
//       return `₹${minPrice} - ₹${livePrice.toFixed(2)}`;
//     }
//     return '';
//   }

//   selectedOption: 'coins' | 'bars' | null = null;
//   lockSeconds = 28;
//   private timerInterval: any;

//   selectOption(
//     option: 'coins' | 'bars',
//     metalType: 'Gold' | 'Silver'
//   ): void {

//     this.selectedOption = option;

//     const modalId =
//       metalType === 'Gold'
//         ? 'buyGoldModalNew'
//         : 'buyGoldModalNewSilver';

//     const modalEl = document.getElementById(modalId);

//     const modalInstance = bootstrap.Modal.getInstance(modalEl!);

//     modalEl?.addEventListener(
//       'hidden.bs.modal',
//       () => {

//         this.forceClearAllBackdrops();

//         this.router.navigate(['/gold-coins'], {
//           queryParams: {
//             metalType
//           }
//         });

//       },
//       { once: true }
//     );

//     modalInstance?.hide();
//   }

//   startPriceLockTimer() {
//     this.timerInterval = setInterval(() => {
//       if (this.lockSeconds > 0) {
//         this.lockSeconds--;
//       } else {
//         clearInterval(this.timerInterval);
//         // price refresh or modal close logic ikkada add cheyandi
//       }
//     }, 1000);
//   }

//   progress = 0;
//   showScrollButton = false;

//   @HostListener('window:scroll')
//   onScroll() {

//     const scrollTop = window.scrollY;

//     const scrollHeight =
//       document.documentElement.scrollHeight -
//       document.documentElement.clientHeight;

//     this.progress =
//       scrollHeight > 0
//         ? (scrollTop / scrollHeight) * 100
//         : 0;

//     this.showScrollButton = scrollTop > 50;
//   }

//   scrollToTop() {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   }

//   // ─── Products page deep-link: open Gold/Silver "what would you like to
//   // buy" popup automatically when ?openModal=gold|silver is present ────────

//   /**
//    * Called once the initial login-check has run. If the person isn't logged
//    * in, send them to login. If they are, and KYC status is already known,
//    * try to open the modal right away — otherwise userProfile() will call
//    * tryOpenPendingProductModal() once KYC status arrives.
//    */
//   private handlePendingProductModal(): void {
//     if (!this.pendingProductModal) return;

//     if (!this.isLogin) {
//       this.toast.warning({
//         detail: 'Login Required',
//         summary: 'Please login to continue',
//         position: 'topCenter',
//       });
//       this.router.navigate(['/login']);
//       this.pendingProductModal = null;
//       return;
//     }

//     if (this.kyc_status !== undefined && this.kyc_status !== null) {
//       this.tryOpenPendingProductModal();
//     }
//   }

//   /**
//    * Opens the correct popup for the pending deep link based on kyc_status.
//    * Safe to call multiple times — it clears pendingProductModal once used.
//    */
//   private tryOpenPendingProductModal(): void {
//     if (!this.pendingProductModal) return;
//     if (this.kyc_status === undefined || this.kyc_status === null) return;

//     const type = this.pendingProductModal;
//     this.pendingProductModal = null;
//     const metal: 'Gold' | 'Silver' = type === 'gold' ? 'Gold' : 'Silver';

//     if (this.kyc_status === 2) {
//       this.callLimit(metal);
//       const modalId = metal === 'Gold' ? 'buyGoldModalNew' : 'buyGoldModalNewSilver';
//       this.openModalById(modalId);
//     } else if (this.kyc_status === 0) {
//       this.openModalById('updateKyx');
//     } else if (this.kyc_status === 1) {
//       this.openModalById('Kyxpending');
//     } else if (this.kyc_status === 3) {
//       this.openModalById('Kyxrejected');
//     }
//   }

//   private openModalById(id: string): void {
//     // Modal DOM might not be painted yet on first tick — retry briefly.
//     const el = document.getElementById(id);
//     if (el) {
//       bootstrap.Modal.getOrCreateInstance(el).show();
//       return;
//     }
//     setTimeout(() => {
//       const retryEl = document.getElementById(id);
//       if (retryEl) {
//         bootstrap.Modal.getOrCreateInstance(retryEl).show();
//       }
//     }, 300);
//   }
// }




import { Component, ElementRef, ViewChild, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { HomeService } from '../services/home.service';
import { Subscription, debounceTime, interval, Subject, takeUntil, forkJoin, of } from 'rxjs';
import { WebSocketService } from '../services/web-socket.service';
import { NgToastService } from 'ng-angular-popup';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';
import { ConfigService } from '../services/config.service';
import { Meta, Title } from '@angular/platform-browser';
import { catchError } from 'rxjs/operators';
import { HostListener } from '@angular/core';
import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend,
  ChartConfiguration,
} from 'chart.js';

// Register only what we need (tree-shakeable)
Chart.register(
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend
);

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
})
export class HomepageComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('exampleModalGold', { static: false }) modalElement!: ElementRef;

  showDiv = {
    previous: true,
    current: true,
    next: true,
  };

  livePrice: any;
  spotGold: any;
  spotSilver: any;
  spotINR: any;
  primium: any = 0;
  spotGoldUpdate: any;
  spotSilverUpdate: any;
  isGold: boolean = true;
  previousSpotSilverUpdate: any;
  spotSilverColor: string = '#e1b737';
  isLogin: any;
  isNotAllowedTime: boolean = true;
  fAmount!: number;

  // Forms
  buyGoldForm: FormGroup;
  bookSilverForm: FormGroup;
  bookGoldForm: FormGroup;

  isTotal: boolean = false;
  isAmountLessThan110: boolean = false;
  isAmountLessThan1000: boolean = false;
  goldMaxLimit: any;
  silverMaxLimit: any;
  kyc_status: any;
  silverPrimium: any = 0;
  treding: boolean = false;
  isWeekendDay: boolean = false;
  phoneNumbers: string[] = [];
  timings: string = '';
  whatsappNumber: string = '';
  email: string = '';
  address: string = '';
  companyname: any;
  backGroundColor: any;
  colorChangeTimeout: any;
  usrID: any;
  profileDetails: any;
  timingsData: any;
  shouldShowAlert: boolean = false;
  buySilverRate: any;
  buyGoldRate: any;

  timerBuy: number = 30;
  timerSubscriptionBuy: Subscription | null = null;
  stayBuyGoldRate: any;
  stayBuySilverRate: any;

  now: Date = new Date();

  previousSpotGoldUpdate: any = 0;
  previousSpotINRUpdate: any = 0;
  spotGoldColor: string = '#e1b737';
  spotINRColor: string = '#e1b737';
  data: string | undefined;

  // Price locking properties
  priceLocked: boolean = false;
  lockedGoldPrice: any = null;
  lockedSilverPrice: any = null;
  lockTimer: number = 0;
  lockInterval: any = null;
  newgoldcard: boolean = false;
  private destroy$ = new Subject<void>();
  private timeSubscription: Subscription | undefined;
  public socketSubscription: Subscription | undefined;
  public livePriceSubscription: Subscription | undefined;

  // Token keys to check
  private readonly TOKEN_KEYS = [
    'user-access',
    'token',
    'user-token-goldBharatFirst'
  ];

  // ─── Product-page → Homepage popup deep link ──────────────────────────────
  // Set from ?openModal=gold|silver|goldBars|silverBars query param, consumed
  // once login/KYC are known.
  //   'gold'      → Gold Coins card  → open the Gold "what would you like to buy" picker
  //   'silver'    → Silver Coins card → open the Silver "what would you like to buy" picker
  //   'goldBars'  → Gold Bars card   → open Buy Gold modal DIRECTLY
  //   'silverBars'→ Silver Bars card → open Buy Silver modal DIRECTLY
  private pendingProductModal: 'gold' | 'silver' | 'goldBars' | 'silverBars' | null = null;
  // ────────────────────────────────────────────────────────────────────────

  // ─── CHART & H/L PROPERTIES (merged from mobileview) ──────────────────────
  goldDayHigh: number = 0;
  goldDayLow: number = 999999;
  silverDayHigh: number = 0;
  silverDayLow: number = 999999;
  goldChangePercent: number = 0;
  silverChangePercent: number = 0;
  selectedTimeframe: string = 'today';

  private goldPriceHistory: { time: string; price: number }[] = [];
  private silverPriceHistory: { time: string; price: number }[] = [];
  private trendChart: Chart | null = null;
  private goldOpenPrice: number = 0;
  private silverOpenPrice: number = 0;
  private chartInitialized: boolean = false;
  // ─────────────────────────────────────────────────────────────────────────

  constructor(
    private home: HomeService,
    private webSocketService: WebSocketService,
    private toast: NgToastService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    public dialog: MatDialog,
    private configService: ConfigService,
    private meta: Meta,
    private titleService: Title
  ) {
    // Initialize forms with correct names and default values
    this.bookGoldForm = this.fb.group({
      product_name: ['Gold'],
      quantity_purchased: ['', [Validators.required]],
      book_rate: [
        '',
        [
          Validators.required,
          Validators.pattern('^\\d*\\.?\\d*$'),
        ],
      ],
      order_type: ['Gold'],
    });

    this.bookSilverForm = this.fb.group({
      product_name: ['Silver'],
      quantity_purchased: ['', [Validators.required]],
      book_rate: [
        '',
        [
          Validators.required,
          Validators.pattern('^\\d*\\.?\\d*$'),
        ],
      ],
      order_type: ['Silver'],
    });

    this.buyGoldForm = this.fb.group({
      product_name: [''],
      quantity_purchased: ['', [Validators.required]],
      purchased_price: [''],
      order_type: [''],
    });
  }

  ngOnInit(): void {
    this.home.getInitialRates().subscribe((res: any) => {
      console.log(res);

      this.spotGoldUpdate = res.carat24.sell_price_per_gram;
      this.spotSilverUpdate = res.silverPrice.sell_price_per_gram;
    });

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const openModal = params['openModal'];
        if (
          openModal === 'gold' ||
          openModal === 'silver' ||
          openModal === 'goldBars' ||
          openModal === 'silverBars'
        ) {
          this.pendingProductModal = openModal;

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {},
            replaceUrl: true
          });
        }
      });

    this.initializeComponent();

    const modalIds = ['buyGoldModalNewSilver', 'buySilverModal', 'buyGoldModalNew', 'buyGoldModal'];
  }

  ngAfterViewInit(): void {
    const modalIds = ['buyGoldModalNew', 'buyGoldModal', 'bookGoldModal', 'buySilverModal', 'bookSilverModal'];

    modalIds.forEach(id => {
      const modalEl = document.getElementById(id);
      modalEl?.addEventListener('hidden.bs.modal', () => {
        this.clearModalBackdrop();
      });
    });

    // Chart canvas is ready; if we already have data, render immediately
    if (this.goldPriceHistory.length > 0) {
      this.updateTrendChart();
    }
  }

  private initializeComponent(): void {
    // Clean up any corrupted data first
    this.cleanupLocalStorage();

    // Initialize in parallel where possible
    forkJoin({
      config: this.loadConfigSafe(),
      initialRates: this.home.getInitialRates().pipe(catchError(() => of(null)))
    }).subscribe({
      next: (results) => {
        if (results.config) {
          this.applyConfig(results.config);
        }
        if (results.initialRates) {
          this.handleInitialRates(results.initialRates);
        }
      },
      complete: () => {
        // These don't depend on each other
        this.checkLoginAndTime();
        this.checkTime();
        this.setMetaTags();
        this.setupRouterEvents();
        this.setupWebSocket();
        this.startTimeUpdates();
        this.isWeekend();

        // Deep-link from products page: try to open the requested popup
        this.handlePendingProductModal();
      }
    });
  }

  /**
   * Clean up corrupted localStorage data
   */
  private cleanupLocalStorage(): void {
    // Remove any 'undefined' string values
    const keysToCheck = ['userData', 'user-details-goldBharat', 'user-token-goldBharatFirst'];
    keysToCheck.forEach(key => {
      const value = localStorage.getItem(key);
      if (value === 'undefined' || value === 'null') {
        localStorage.removeItem(key);
      }
    });

    // Validate userData JSON
    const userDataString = localStorage.getItem('userData');
    if (userDataString) {
      try {
        JSON.parse(userDataString);
      } catch {
        // Corrupted JSON, remove it
        localStorage.removeItem('userData');
      }
    }
  }


  private loadConfigSafe() {
    return this.configService.loadConfig().pipe(
      catchError(error => {
        console.error('Error loading config:', error);
        return of(null);
      })
    );
  }

 
  private applyConfig(config: any): void {
    if (config?.contact) {
      this.phoneNumbers = config.contact.phoneNumbers || [];
      this.timings = config.contact.timings || '';
      this.whatsappNumber = config.contact.whatsappNumber || '';
      this.email = config.contact.email || '';
      this.address = config.contact.address || '';
      this.companyname = config.company?.companyname || '';
      this.backGroundColor = config.company;
    }
  }


  private handleInitialRates(data: any): void {
    if (data) {
      this.spotGoldUpdate = data.carat24?.sell_price_per_gram;
      this.spotSilverUpdate = data.silverPrice?.sell_price_per_gram;
      this.spotGold = data.carat24?.spot_gold;
      this.spotSilver = data.silverPrice?.spot_silver;
      this.spotINR = data.carat24?.spot_inr;

      // Set initial buy rates
      this.stayBuyGoldRate = this.spotGoldUpdate;
      this.stayBuySilverRate = this.spotSilverUpdate;

      console.log('Initial rates loaded:', {
        gold: this.spotGoldUpdate,
        silver: this.spotSilverUpdate
      });

      // Seed H/L and trend chart with initial rates
      this.recordPriceHistory();
    }
  }

  private setMetaTags(): void {
    this.titleService.setTitle('Buy Gold & Silver In Bulk At Best Price | Goldbharat');

    this.meta.updateTag({
      name: 'description',
      content: 'Buy bulk gold and silver at unbeatable prices. Secure your wealth with high-quality precious metals, ideal for investors seeking long-term reliability and value protection.',
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'buy gold wholesale, buy gold in bulk, buy gold wholesale direct, gold price today',
    });
  }

  private setupRouterEvents(): void {
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          window.scrollTo(0, 0);
        }
      });
  }

  private setupWebSocket(): void {
    this.spotGoldUpdate = 0;
    this.spotSilverUpdate = 0;
    this.previousSpotGoldUpdate = 0;
    this.previousSpotINRUpdate = 0;
    this.previousSpotSilverUpdate = 0;

    this.spotGoldColor = '#e1b737';
    this.spotSilverColor = '#e1b737';
    this.spotINRColor = '#e1b737';

    this.socketSubscription = this.webSocketService
      .startFetching()
      .pipe(
        debounceTime(500),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (message: string) => {
          this.handleWebSocketMessage(message);
        },
        error: (error: any) => {
          console.error('WebSocket error:', error);
        }
      });
  }

  private startTimeUpdates(): void {
    this.timeSubscription = interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateTime();
      });
  }

  /**
   * Get rates with filtering options for chart
   * @param metal - 'gold' or 'silver'
   * @param duration - 'day', 'week', 'month', 'year'
   * @param interval - 'hourly', 'daily', 'weekly', 'monthly'
   * @param gap - gap between data points
   */
  getRates(metal: string, duration?: string, interval?: string, gap?: number) {
    let url = `/api/live-rates?metal=${metal}`;
    if (duration) url += `&duration=${duration}`;
    if (interval) url += `&interval=${interval}`;
    if (gap) url += `&gap=${gap}`;

    return this.http.get(url);
  }

  /**
   * Get statistics for a metal (High/Low data)
   * @param metal - 'gold' or 'silver'
   * @param period - 'day', 'week', 'month', 'year'
   */
  getStatistics(metal: string, period: string) {
    return this.http.get(`/api/live-stats?metal=${metal}&period=${period}`);
  }

  updateTime(): void {
    this.now = new Date();
  }

  isWeekend(): void {
    this.now = new Date();
    const day = this.now.toLocaleString('en-us', { weekday: 'short' });
    const isWeekend = day === 'Sat' || day === 'Sun';

    if (this.kyc_status !== 2) {
      this.treding = !isWeekend;
      this.isWeekendDay = isWeekend;
    } else {
      this.treding = true;
      this.isWeekendDay = false;
    }
  }

  checkTime(): void {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentDay = now.getDay();

    const isBefore930AM =
      currentHour < 9 || (currentHour === 9 && currentMinute < 30);
    const isAfter1130PM =
      currentHour > 23 || (currentHour === 23 && currentMinute >= 30);
    const isWeekday = currentDay >= 1 && currentDay <= 5;

    this.shouldShowAlert = (isBefore930AM || isAfter1130PM) && isWeekday;
  }


  private getToken(): string | null {
    for (const key of this.TOKEN_KEYS) {
      const token = localStorage.getItem(key);
      if (token && token !== 'undefined' && token !== 'null') {
        return token;
      }
    }
    return null;
  }


  private getUserData(): any {
    const userDataString = localStorage.getItem('userData');
    if (!userDataString || userDataString === 'undefined' || userDataString === 'null') {
      return null;
    }

    try {
      return JSON.parse(userDataString);
    } catch {
      return null;
    }
  }

  checkLoginAndTime(): void {
    const token = this.getToken();
    this.isLogin = !!token;
    console.log('Is logged in:', this.isLogin);

    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    const isRestrictedTime = (currentHour === 23 && currentMinute >= 30) ||
      (currentHour >= 0 && currentHour < 9) ||
      (currentHour === 9 && currentMinute < 30);

    this.isNotAllowedTime = !isRestrictedTime;

    if (this.isLogin && this.isNotAllowedTime) {
      this.userProfile();
    }
  }

  // Gold amount validation
  userAmount(userInput: any): void {
    if (userInput) {
      const livePrice = parseFloat(this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate);
      const enteredAmount = parseFloat(userInput);

      // Check if it's a valid number
      if (isNaN(enteredAmount)) {
        this.isAmountLessThan110 = false;
        return;
      }

      // Calculate difference (live price - entered amount)
      const difference = livePrice - enteredAmount;

      console.log('Gold validation:', {
        livePrice,
        enteredAmount,
        difference,
        isValid: difference >= 0 && difference <= 110
      });

      // Valid if:
      // 1. Entered amount is not higher than live price (difference >= 0)
      // 2. Difference is within 110 rupees (difference <= 110)
      if (difference >= 0 && difference <= 110) {
        this.isAmountLessThan110 = true;
      } else {
        this.isAmountLessThan110 = false;

        if (enteredAmount > livePrice) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
            position: 'topCenter',
          });
        } else if (difference > 110) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Amount too low. Must be within ₹110 of locked price. Minimum allowed: ₹${(livePrice - 110).toFixed(2)}`,
            position: 'topCenter',
          });
        }
      }
    }
  }

  // Silver amount validation
  userAmountSilver(userInput: any): void {
    if (userInput) {
      const livePrice = parseFloat(this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate);
      const enteredAmount = parseFloat(userInput);

      if (isNaN(enteredAmount)) {
        this.isAmountLessThan1000 = false;
        return;
      }

      const difference = livePrice - enteredAmount;

      console.log('Silver validation:', {
        livePrice,
        enteredAmount,
        difference,
        isValid: difference >= 0 && difference <= 1000
      });

      if (difference >= 0 && difference <= 1000) {
        this.isAmountLessThan1000 = true;
      } else {
        this.isAmountLessThan1000 = false;

        if (enteredAmount > livePrice) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
            position: 'topCenter',
          });
        } else if (difference > 1000) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Amount too low. Must be within ₹1000 of locked price. Minimum allowed: ₹${(livePrice - 1000).toFixed(2)}`,
            position: 'topCenter',
          });
        }
      }
    }
  }

  checkLogIn(): void {
    this.toast.warning({
      detail: 'Login Required!',
      summary: 'Please login for book gold',
      position: 'topCenter',
    });
  }

  // Method to lock the price
  lockPrice(type: string): void {
    // Clear any existing lock timer
    if (this.lockInterval) {
      clearInterval(this.lockInterval);
    }

    // Set locked prices
    if (type === 'Gold') {
      this.lockedGoldPrice = this.stayBuyGoldRate;
    } else {
      this.lockedSilverPrice = this.stayBuySilverRate;
    }

    this.priceLocked = true;
    this.lockTimer = 30;

    // Start countdown
    this.lockInterval = setInterval(() => {
      this.lockTimer--;

      if (this.lockTimer <= 0) {
        this.unlockPrice();
      }
    }, 1000);

    console.log(`Price locked for ${type} at ${type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice} for 30 seconds`);
    const lockData = {
      type: type,
      lockedPrice: type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice,
      timer: this.lockTimer,
      lockedAt: new Date().toISOString()
    };

    localStorage.setItem('lockedPriceData', JSON.stringify(lockData));

    console.log(lockData.lockedPrice, 'newwwwwwwLocked');
  }

  // Method to unlock the price
  unlockPrice(): void {
    this.priceLocked = false;
    this.lockedGoldPrice = null;
    this.lockedSilverPrice = null;
    this.lockTimer = 0;

    if (this.lockInterval) {
      clearInterval(this.lockInterval);
      this.lockInterval = null;
    }

    console.log('Price unlocked');
  }

  // Updated buy submit with price locking
  onBuySubmit(value: string): void {
    const token = this.getToken();
    if (!token) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to make a purchase',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      return;
    }

    // Check if price is locked for this type
    if (value === 'Gold' && !this.lockedGoldPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Buy button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    if (value === 'Silver' && !this.lockedSilverPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Buy button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    if (!this.buyGoldForm.valid) {
      this.toast.warning({
        detail: 'Invalid Form',
        summary: 'Please fill all required fields',
        position: 'topCenter',
      });
      return;
    }

    const quantity = this.buyGoldForm.get('quantity_purchased')?.value;
    if (!quantity) {
      this.toast.warning({
        detail: 'Quantity Required',
        summary: 'Please select a quantity',
        position: 'topCenter',
      });
      return;
    }

    // Use locked price instead of live price
    const price = value === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice;

    // Format price for backend
    const formattedPrice = value === 'Gold'
      ? Math.floor(parseFloat(price)).toString()
      : parseFloat(price).toFixed(2);

    const orderData = {
      product_name: value,
      quantity_purchased: quantity.toString(),
      purchased_price: formattedPrice,
      order_type: value
    };

    console.log('Sending order data with locked price:', orderData);

    this.spinner.show();

    this.home.buyGoldAnsSilver(orderData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.toast.success({
            detail: 'Success!',
            summary: res.msg || 'Order placed successfully',
            position: 'topCenter',
          });
          this.buyGoldForm.reset();
          this.unlockPrice(); // Unlock price after successful purchase
          this.goldLimit();
          this.silverLimit();

          setTimeout(() => {
            this.router.navigate(['/orders']);
          }, 1000);
        },
        error: (err: any) => {
          this.spinner.hide();
          console.error('Order error:', err);
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            this.toast.error({
              detail: 'Oops!',
              summary: err.error?.msg || 'Something went wrong',
              position: 'topCenter',
            });
          }
        }
      });
  }

  // Updated gold submit with price locking
  onGoldSubmit(value: string): void {
    const token = this.getToken();
    if (!token) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to book gold/silver',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      return;
    }

    // Check if price is locked
    if (value === 'gold' && !this.lockedGoldPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Book button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    if (value === 'silver' && !this.lockedSilverPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Book button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    const form = value === 'gold' ? this.bookGoldForm : this.bookSilverForm;

    if (!form.valid) {
      this.toast.warning({
        detail: 'Invalid Form',
        summary: 'Please fill all required fields',
        position: 'topCenter',
      });
      return;
    }

    const quantity = form.get('quantity_purchased')?.value;
    const bookRate = form.get('book_rate')?.value;

    if (!quantity || !bookRate) {
      this.toast.warning({
        detail: 'Missing Information',
        summary: 'Please select quantity and enter amount',
        position: 'topCenter',
      });
      return;
    }

    // Use locked price for validation
    const livePrice = value === 'gold'
      ? parseFloat(this.lockedGoldPrice)
      : parseFloat(this.lockedSilverPrice);

    const enteredAmount = parseFloat(bookRate);
    const difference = livePrice - enteredAmount;

    if (value === 'gold' && (difference < 0 || difference > 110)) {
      this.toast.warning({
        detail: 'Invalid Amount',
        summary: `Amount must be between ₹${(livePrice - 110).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
        position: 'topCenter',
      });
      return;
    }

    if (value === 'silver' && (difference < 0 || difference > 1000)) {
      this.toast.warning({
        detail: 'Invalid Amount',
        summary: `Amount must be between ₹${(livePrice - 1000).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
        position: 'topCenter',
      });
      return;
    }

    const bookingData = {
      product_name: value === 'gold' ? 'Gold' : 'Silver',
      quantity_purchased: quantity.toString(),
      book_rate: bookRate.toString(),
      order_type: value === 'gold' ? 'Gold' : 'Silver'
    };

    console.log('Sending booking data with locked price:', bookingData);

    this.spinner.show();

    this.home.bookGoldAndSilver(bookingData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.toast.success({
            detail: 'Success!',
            summary: res.msg || 'Booking successful',
            position: 'topCenter',
          });
          form.reset();

          if (value === 'gold') {
            this.bookGoldForm.patchValue({
              product_name: 'Gold',
              order_type: 'Gold'
            });
          } else {
            this.bookSilverForm.patchValue({
              product_name: 'Silver',
              order_type: 'Silver'
            });
          }
          this.unlockPrice(); 
          this.goldLimit();
          this.silverLimit();
        },
        error: (err: any) => {
          this.spinner.hide();
          console.error('Booking error:', err);
          this.toast.error({
            detail: 'Error!',
            summary: err.error?.msg || 'Something went wrong',
            position: 'topCenter',
          });
        }
      });
  }

  openDialog(): void {
    this.dialog.open(PopupDialogComponent, {
      width: '500px',
      panelClass: 'custom-dialog-container',
    });
  }

  private handleWebSocketMessage(message: string): void {
    this.data = message;

    if (!message || message === 'undefined' || message === 'null' || message.trim() === '' || message.length < 2) {
      return;
    }

    try {
      if (message.startsWith('42')) {
        const jsonStr = message.substring(2);

        if (!jsonStr || jsonStr.trim() === '' || jsonStr === 'undefined') {
          return;
        }

        const jsonMessage = JSON.parse(jsonStr);

        if (!Array.isArray(jsonMessage) || jsonMessage.length < 2) {
          return;
        }

        const priceData = jsonMessage[1];
        if (!priceData || !priceData.updatedata) {
          return;
        }

        const eventData = priceData.updatedata;
        if (eventData === 'undefined' || !eventData) {
          return;
        }

        const jsonData = JSON.parse(eventData);
        const dataArray = Array.isArray(jsonData) ? jsonData : [jsonData];

        const filteredData = dataArray.filter(
          (item: any) => item?.gold1_symbol &&
            ['SPOT-INR', 'SPOT-SILVER', 'SPOT-GOLD'].includes(item.gold1_symbol)
        );

        if (filteredData.length >= 3) {
          filteredData.forEach((item: any) => {
            switch (item.gold1_symbol) {
              case 'SPOT-GOLD':
                this.spotGold = item.gold1_ask;
                break;
              case 'SPOT-SILVER':
                this.spotSilver = item.gold1_ask;
                break;
              case 'SPOT-INR':
                this.spotINR = item.gold1_ask;
                break;
            }
          });

          if (!this.priceLocked) {
            this.fetchPremiums();
          }
        }
      }
    } catch (error) {

    }
  }

  private filterData(data: any[]): any[] {
    return data.filter(
      (item: any) =>
        item.gold1_symbol === 'SPOT-INR' ||
        item.gold1_symbol === 'SPOT-SILVER' ||
        item.gold1_symbol === 'SPOT-GOLD'
    );
  }

  private fetchPremiums(): void {
    this.http.get('https://liverates-api.goldcentral.in/api/getpremium')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.premium !== undefined) {
            this.primium = res.premium;
            this.fetchSilverPremium();
          }
        },
        error: (error: any) => {
          console.error('Error fetching premium:', error);
        }
      });
  }

  private fetchSilverPremium(): void {
    this.http.get('https://liverates-api.goldcentral.in/api/getSilverPremium')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.premium !== undefined) {
            this.silverPrimium = res.premium;
            this.calculateUpdatedPrices();
          }
        },
        error: (error: any) => {
          console.error('Error fetching silver premium:', error);
        }
      });
  }

  private calculateUpdatedPrices(): void {
    const ozToGrams = 31.102;
    const GOV_GOLD_TAX = 6.25;
    const GOV_SILVER_TAX = 6.75;
    const GST_TAX_PERCENTAGE = 0;

    const totalChargesPercentage = GOV_GOLD_TAX + GST_TAX_PERCENTAGE;

    // Gold price calculation
    const checkGold1 = this.spotGold / ozToGrams;
    const INRrupeeGold = checkGold1 * this.spotINR;
    let convGold: number = (INRrupeeGold / 100) * totalChargesPercentage + INRrupeeGold;
    convGold += (convGold * this.primium) / 100;
    this.spotGoldUpdate = convGold.toFixed(2);

    // Only update stayBuyGoldRate if price is not locked
    if (!this.priceLocked || !this.lockedGoldPrice) {
      this.stayBuyGoldRate = this.spotGoldUpdate;
    }

    // Silver price calculation
    const checkSilver = (this.spotSilver / 31.1) * this.spotINR * 1000;
    const inrSilver = checkSilver + (checkSilver / 100) * GOV_SILVER_TAX;
    const finalSilver = inrSilver + (inrSilver * this.silverPrimium) / 1000;
    this.spotSilverUpdate = (finalSilver + 100).toFixed(2);

    // Only update stayBuySilverRate if price is not locked
    if (!this.priceLocked || !this.lockedSilverPrice) {
      this.stayBuySilverRate = this.spotSilverUpdate;
    }

    this.updatePriceColors();
    this.recordPriceHistory(); // ← update chart & H/L on every price tick
  }

  private updatePriceColors(): void {
    this.spotGoldColor = this.getColor(this.spotGoldUpdate, this.previousSpotGoldUpdate);
    this.spotINRColor = this.getColor(this.spotINR, this.previousSpotINRUpdate);
    this.spotSilverColor = this.getColor(this.spotSilverUpdate, this.previousSpotSilverUpdate);

    setTimeout(() => {
      this.previousSpotGoldUpdate = this.spotGoldUpdate;
      this.previousSpotSilverUpdate = this.spotSilverUpdate;
      this.previousSpotINRUpdate = this.spotINR;
    }, 100);
  }

  private getColor(current: number | string, previous: number | string): string {
    const currentNum = typeof current === 'string' ? parseFloat(current) : current;
    const previousNum = typeof previous === 'string' ? parseFloat(previous) : previous;

    if (currentNum > previousNum) return '#FE4A54';
    if (currentNum < previousNum) return '#76f590';
    return '#e1b737';
  }

  public isWeekendCheck(): boolean {
    const currentDay = new Date().getDay();
    return currentDay === 0 || currentDay === 6;
  }

  // Updated callLimit with price locking
  callLimit(value: string): void {
    this.newgoldcard = true;
    const token = this.getToken();
    if (!token) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to view limits',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      return;
    }

    // Lock the price when button is clicked
    this.lockPrice(value);

    if (value === 'Gold') {
      this.goldLimit();
      this.timerBuy = 30;
      this.startTimer();
    } else {
      this.silverLimit();
      this.timerBuy = 30;
      this.startTimer();
    }
  }

  callLimitt() {
    this.newgoldcard = true;
  }

  goldLimit(): void {
    this.home.getGoldLimit()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.goldMaxLimit = res.maxLimitValues;
        },
        error: (err: any) => {
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            console.error('Error fetching gold limit:', err);
          }
        }
      });
  }

  silverLimit(): void {
    this.home.getSilverLimit()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.silverMaxLimit = res.silverMaxLimitValues;
        },
        error: (err: any) => {
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            console.error('Error fetching silver limit:', err);
          }
        }
      });
  }

  userProfile(): void {
    const token = this.getToken();
    if (!token) {
      console.log('No token found, user not logged in');
      this.isLogin = false;
      return;
    }

    this.auth.userDetailGet()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            const data = res.data;
            this.profileDetails = data.userData;
            this.kyc_status = data.kyc_status;

            if (data.userData) {
              const userDataToStore = {
                id: data.userData?.id,
                kyc_status: data.kyc_status,
                ...data.userData
              };
              localStorage.setItem('userData', JSON.stringify(userDataToStore));
            }

            if (data.token) {
              const newToken = data.token.startsWith('Bearer ') ? data.token : `Bearer ${data.token}`;
              localStorage.setItem('user-access', newToken);
            }

            this.getTimingsbyId();

  
            this.tryOpenPendingProductModal();
          }
        },
        error: (err: any) => {
          if (err.status === 401) {
            console.error('Session expired:', err);
            this.handleSessionExpired();
          } else {
            console.error('Error fetching user profile:', err);
          }
        }
      });
  }

  private handleSessionExpired(): void {
    this.TOKEN_KEYS.forEach(key => localStorage.removeItem(key));
    localStorage.removeItem('userData');
    localStorage.removeItem('user-details-goldBharat');

    this.isLogin = false;
    this.kyc_status = null;
    this.profileDetails = null;

    this.toast.warning({
      detail: 'Session Expired',
      summary: 'Please login again to continue',
      duration: 3000,
      position: 'topCenter'
    });

    this.router.navigate(['/login']);
  }

  getWhatsAppLink(number: string): string {
    const formattedNumber = number.replace(/\D/g, '');
    return `https://wa.me/${formattedNumber}`;
  }

  getTimingsbyId(): void {
    const userData = this.getUserData();

    if (!userData) {
      console.log('User data not found in localStorage');
      return;
    }
    if (!userData?.id) {
      console.error('User ID not found in user data');
      if (this.isLogin) {
        this.userProfile();
      }
      return;
    }

    const token = this.getToken();
    if (!token) {
      console.log('No token found, skipping timings fetch');
      return;
    }

    if (userData.kyc_status !== 0 && userData.kyc_status !== undefined) {
      this.home.getTimings(userData.id)
        .pipe(
          takeUntil(this.destroy$),
          catchError(err => {
            if (err.status === 401) {
              this.handleSessionExpired();
            }
            return of(null);
          })
        )
        .subscribe({
          next: (response: any) => {
            if (response) {
              this.timingsData = response;
              console.log('Timings loaded:', this.timingsData);
            }
          }
        });
    }
  }

  goldSilverRateStay(): void {
    this.home.getInitialRates()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (data) {
            // Only update if price is not locked
            if (!this.priceLocked || !this.lockedGoldPrice) {
              this.stayBuyGoldRate = data.carat24?.sell_price_per_gram;
            }

            if (!this.priceLocked || !this.lockedSilverPrice) {
              this.stayBuySilverRate = data.silverPrice?.sell_price_per_gram;
            }
          }
        },
        error: (err: any) => {
          console.error('Error fetching rates:', err);
        }
      });
  }

  startTimer(): void {
    this.stopTimer();

    this.timerSubscriptionBuy = interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.timerBuy--;
        if (this.timerBuy <= 0) {
          this.timerBuy = 30;
          // Don't reload the page, just refresh rates if not locked
          if (!this.priceLocked) {
            this.goldSilverRateStay();
          }
        }
      });
  }

  stopTimer(): void {
    if (this.timerSubscriptionBuy) {
      this.timerSubscriptionBuy.unsubscribe();
      this.timerSubscriptionBuy = null;
    }
  }

  // Updated closeModal to unlock price
  closeModal(): void {
    this.stopTimer();
    this.unlockPrice();
    this.selectedOption = null;

    const openModalEl = document.querySelector('.modal.show') as HTMLElement | null;

    if (openModalEl) {
      const modalInstance = bootstrap.Modal.getOrCreateInstance(openModalEl);

      openModalEl.addEventListener('hidden.bs.modal', () => {
        this.forceClearAllBackdrops();
      }, { once: true });

      modalInstance.hide();

      setTimeout(() => {
        this.forceClearAllBackdrops();
      }, 400);

    } else {

      this.forceClearAllBackdrops();
    }
  }

  forceClearAllBackdrops(): void {

    document.querySelectorAll('.modal-backdrop').forEach((el: any) => {
      el.remove();
    });

    document.querySelectorAll('.modal').forEach((modal: any) => {
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    });

    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');

  }
  switchToBuyGoldModal(): void {
    const currentModalEl = document.getElementById('buyGoldModalNew');
    const currentModal = bootstrap.Modal.getInstance(currentModalEl!);

    currentModalEl?.addEventListener('hidden.bs.modal', () => {
      this.clearModalBackdrop();
      const nextModalEl = document.getElementById('buyGoldModal');
      const nextModal = new bootstrap.Modal(nextModalEl!);
      nextModal.show();
    }, { once: true });

    currentModal?.hide();
    this.selectedOption = 'bars';
  }

  switchToBuyGoldModalsilver(): void {
    const currentModalEl = document.getElementById('buyGoldModalNewSilver');
    const currentModal = bootstrap.Modal.getOrCreateInstance(currentModalEl!);

    currentModalEl?.addEventListener('hidden.bs.modal', () => {
      this.forceClearAllBackdrops();
      const nextModalEl = document.getElementById('buySilverModal');
      const nextModal = bootstrap.Modal.getOrCreateInstance(nextModalEl!);
      nextModal.show();
    }, { once: true });

    currentModal.hide();
    this.selectedOption = 'bars';
  }

  private clearModalBackdrop(): void {
    const openModals = document.querySelectorAll('.modal.show');
    const backdrops = document.querySelectorAll('.modal-backdrop');

    if (openModals.length === 0 && backdrops.length > 0) {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      backdrops.forEach(el => el.remove());
    }
  }

  // ─── CHART & H/L METHODS (merged from mobileview) ──────────────────────────

  /**
   * Called after every price calculation tick (and once on initial rates).
   * Records a new data point and updates H/L, % change, and the chart.
   */
  private recordPriceHistory(): void {
    const goldPrice = parseFloat(this.spotGoldUpdate);
    const silverPrice = parseFloat(this.spotSilverUpdate);

    if (!goldPrice || !silverPrice || isNaN(goldPrice) || isNaN(silverPrice)) return;

    // Set open price (first seen price of the session)
    if (this.goldOpenPrice === 0) this.goldOpenPrice = goldPrice;
    if (this.silverOpenPrice === 0) this.silverOpenPrice = silverPrice;

    // Update Day High / Low
    if (goldPrice > this.goldDayHigh) this.goldDayHigh = goldPrice;
    if (goldPrice < this.goldDayLow) this.goldDayLow = goldPrice;
    if (silverPrice > this.silverDayHigh) this.silverDayHigh = silverPrice;
    if (silverPrice < this.silverDayLow) this.silverDayLow = silverPrice;

    // Change % vs session open
    this.goldChangePercent = ((goldPrice - this.goldOpenPrice) / this.goldOpenPrice) * 100;
    this.silverChangePercent = ((silverPrice - this.silverOpenPrice) / this.silverOpenPrice) * 100;

    // Time label
    const now = new Date();
    const timeLabel = now.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
    });

    // Append & cap at 60 points (≈ 1 point every WebSocket tick, ~30 min of data)
    this.goldPriceHistory.push({ time: timeLabel, price: goldPrice });
    this.silverPriceHistory.push({ time: timeLabel, price: silverPrice });

    if (this.goldPriceHistory.length > 60) this.goldPriceHistory.shift();
    if (this.silverPriceHistory.length > 60) this.silverPriceHistory.shift();

    this.updateTrendChart();
  }

  /**
   * Creates or updates the Chart.js line chart.
   */
  private updateTrendChart(): void {
    const canvas = document.getElementById('trendChart') as HTMLCanvasElement | null;
    if (!canvas) return;

    const labels = this.goldPriceHistory.map(p => p.time);
    const goldData = this.goldPriceHistory.map(p => p.price);
    const silverData = this.silverPriceHistory.map(p => p.price);

    // If the chart already exists, just push new data without re-creating it
    if (this.trendChart) {
      this.trendChart.data.labels = labels;
      this.trendChart.data.datasets[0].data = goldData;
      this.trendChart.data.datasets[1].data = silverData;
      this.trendChart.update('none'); // 'none' skips animation for performance
      return;
    }

    // First-time creation
    const config: ChartConfiguration<'line'> = {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Gold (₹/g)',
            data: goldData,
            borderColor: '#e1b737',
            backgroundColor: 'rgba(225,183,55,0.12)',
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 4,
            fill: true,
            tension: 0.4,
            yAxisID: 'yGold',
          },
          {
            label: 'Silver (₹/kg)',
            data: silverData,
            borderColor: '#a8aab1',
            backgroundColor: 'rgba(168,170,177,0.06)',
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 4,
            fill: false,
            tension: 0.4,
            yAxisID: 'ySilver',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 0 },
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#030F55',
            titleColor: '#a0a8c8',
            bodyColor: '#ffffff',
            borderColor: '#464E8A',
            borderWidth: 1,
            padding: 10,
            callbacks: {
              label: (ctx) => {
                const val = ctx.parsed.y;
                return ctx.datasetIndex === 0
                  ? ` Gold: ₹${(val ?? 0).toFixed(2)}/g`
                  : ` Silver: ₹${(val ?? 0).toFixed(2)}/kg`;
              },
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: '#a0a8c8',
              maxTicksLimit: 6,
              font: { size: 10 },
            },
            grid: { color: 'rgba(255,255,255,0.05)' },
          },
          yGold: {
            position: 'left',
            ticks: { color: '#e1b737', font: { size: 10 } },
            grid: { color: 'rgba(255,255,255,0.05)' },
          },
          ySilver: {
            position: 'right',
            ticks: { color: '#a8aab1', font: { size: 10 } },
            grid: { drawOnChartArea: false },
          },
        },
      },
    };

    this.trendChart = new Chart(canvas, config);
    this.chartInitialized = true;
  }

  /**
   * Called when the timeframe dropdown changes.
   * Resets history and destroys the current chart so it rebuilds fresh.
   */
  onTimeframeChange(): void {
    this.goldPriceHistory = [];
    this.silverPriceHistory = [];
    this.goldOpenPrice = 0;
    this.silverOpenPrice = 0;
    this.goldDayHigh = 0;
    this.goldDayLow = 999999;
    this.silverDayHigh = 0;
    this.silverDayLow = 999999;
    this.goldChangePercent = 0;
    this.silverChangePercent = 0;

    if (this.trendChart) {
      this.trendChart.destroy();
      this.trendChart = null;
    }
  }

  // ─────────────────────────────────────────────────────────────────────────

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.stopTimer();

    // Clear lock interval
    if (this.lockInterval) {
      clearInterval(this.lockInterval);
    }

    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }

    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }

    // Destroy chart to prevent memory leak
    if (this.trendChart) {
      this.trendChart.destroy();
      this.trendChart = null;
    }
  }

  // Helper methods to get valid ranges
  getValidGoldRange(): string {
    const price = this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate;
    if (price) {
      const livePrice = parseFloat(price);
      const minPrice = (livePrice - 110).toFixed(2);
      return `₹${minPrice} - ₹${livePrice.toFixed(2)}`;
    }
    return '';
  }

  getValidSilverRange(): string {
    const price = this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate;
    if (price) {
      const livePrice = parseFloat(price);
      const minPrice = (livePrice - 1000).toFixed(2);
      return `₹${minPrice} - ₹${livePrice.toFixed(2)}`;
    }
    return '';
  }

  selectedOption: 'coins' | 'bars' | null = null;
  lockSeconds = 28;
  private timerInterval: any;

  // selectOption(
  //   option: 'coins' | 'bars',
  //   metalType: 'Gold' | 'Silver'
  // ): void {

  //   this.selectedOption = option;

  //   const modalId =
  //     metalType === 'Gold'
  //       ? 'buyGoldModalNew'
  //       : 'buyGoldModalNewSilver';

  //   const modalEl = document.getElementById(modalId);

  //   const modalInstance = bootstrap.Modal.getInstance(modalEl!);

  //   modalEl?.addEventListener(
  //     'hidden.bs.modal',
  //     () => {

  //       this.forceClearAllBackdrops();

  //       this.router.navigate(['/gold-coins'], {
  //         queryParams: {
  //           metalType
  //         }
  //       });

  //     },
  //     { once: true }
  //   );

  //   modalInstance?.hide();
  // }

  selectOption(
  option: 'coins' | 'bars',
  metalType: 'Gold' | 'Silver'
): void {

  this.selectedOption = option;

  const modalId =
    metalType === 'Gold'
      ? 'buyGoldModalNew'
      : 'buyGoldModalNewSilver';

  const modalEl = document.getElementById(modalId);

  const modalInstance = bootstrap.Modal.getInstance(modalEl!);

  modalEl?.addEventListener(
    'hidden.bs.modal',
    () => {

      this.forceClearAllBackdrops();

      this.router.navigate(['/gold-coins'], {
        queryParams: {
          metalType,
          from: 'home'
        }
      });

    },
    { once: true }
  );

  modalInstance?.hide();
}

  startPriceLockTimer() {
    this.timerInterval = setInterval(() => {
      if (this.lockSeconds > 0) {
        this.lockSeconds--;
      } else {
        clearInterval(this.timerInterval);
        // price refresh or modal close logic ikkada add cheyandi
      }
    }, 1000);
  }

  progress = 0;
  showScrollButton = false;

  @HostListener('window:scroll')
  onScroll() {

    const scrollTop = window.scrollY;

    const scrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    this.progress =
      scrollHeight > 0
        ? (scrollTop / scrollHeight) * 100
        : 0;

    this.showScrollButton = scrollTop > 50;
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // ─── Products page deep-link: open Gold/Silver buy popup automatically
  // when ?openModal=gold|silver|goldBars|silverBars is present ────────────

  /**
   * Called once the initial login-check has run. If the person isn't logged
   * in, send them to login. If they are, and KYC status is already known,
   * try to open the modal right away — otherwise userProfile() will call
   * tryOpenPendingProductModal() once KYC status arrives.
   */
  private handlePendingProductModal(): void {
    if (!this.pendingProductModal) return;

    if (!this.isLogin) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to continue',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      this.pendingProductModal = null;
      return;
    }

    if (this.kyc_status !== undefined && this.kyc_status !== null) {
      this.tryOpenPendingProductModal();
    }
  }

  /**
   * Opens the correct popup for the pending deep link based on kyc_status
   * AND the requested variant (bars → direct buy modal, coins → picker modal).
   * Safe to call multiple times — it clears pendingProductModal once used.
   */
  private tryOpenPendingProductModal(): void {
    if (!this.pendingProductModal) return;
    if (this.kyc_status === undefined || this.kyc_status === null) return;

    const type = this.pendingProductModal;
    this.pendingProductModal = null;

    const isSilver = type === 'silver' || type === 'silverBars';
    const metal: 'Gold' | 'Silver' = isSilver ? 'Silver' : 'Gold';

    if (this.kyc_status === 2) {
      this.callLimit(metal); // locks the price + writes lockedPriceData to localStorage

      if (type === 'goldBars') {
        this.openModalById('buyGoldModal');        // direct Buy Gold modal
      } else if (type === 'silverBars') {
        this.openModalById('buySilverModal');      // direct Buy Silver modal
      } else {
        // 'gold' or 'silver' → Coins flow: skip the picker, go straight to the coins page
       this.router.navigate(['/gold-coins'], {
  queryParams: {
    metalType: metal,
    from: 'home'
  }
});
      }
    } else if (this.kyc_status === 0) {
      this.openModalById('updateKyx');
    } else if (this.kyc_status === 1) {
      this.openModalById('Kyxpending');
    } else if (this.kyc_status === 3) {
      this.openModalById('Kyxrejected');
    }
  }

  private openModalById(id: string): void {
    // Modal DOM might not be painted yet on first tick — retry briefly.
    const el = document.getElementById(id);
    if (el) {
      bootstrap.Modal.getOrCreateInstance(el).show();
      return;
    }
    setTimeout(() => {
      const retryEl = document.getElementById(id);
      if (retryEl) {
        bootstrap.Modal.getOrCreateInstance(retryEl).show();
      }
    }, 300);
  }
}